(function(){
'use strict';
var MC_API='https://script.google.com/macros/s/AKfycbx4cDDEvk8YNl8_ObUtTyXL44ASWsO24yYbN4RUmPpSekq3eGhyuZGRQ4ieg8_DBoUq/exec';
var MC_TOKEN='mc_cc6f126b6aaf46bfa553068c22727813';

var igData=null, igMedia=[], period=30, mediaType='', mediaSort='recent';
var igFollowerHistory=[];
var mediaPage=0, MEDIA_PER_PAGE=9;
var chartMode='daily'; // 'daily' = saldo diário | 'total' = evolução total

/* ── Estado DMs + Comentários ── */
var dmsAll=[], dmsCursor=null, dmsLoading=false;
var cmtOffset=0, cmtHasMore=true, cmtLoading=false;
var cmtReplies=(function(){try{return JSON.parse(localStorage.getItem('mc_cmt_replies')||'{}');}catch(e){return{};}}()); // persistido em localStorage

/* ── Cache ── */
var TTL_ACCOUNT=30*60*1000, TTL_MEDIA=4*60*60*1000;

function cacheKey(base){ return 'mc_ig_'+base+'_'+period; }
function cacheGet(key){
  try{
    var s=JSON.parse(localStorage.getItem(key));
    if(!s||!s.ts) return null;
    return (Date.now()-s.ts)<(s.ttl||TTL_ACCOUNT)?s.d:null;
  }catch(e){return null;}
}
function cacheSave(key,data,ttl){
  try{localStorage.setItem(key,JSON.stringify({ts:Date.now(),ttl:ttl,d:data}));}catch(e){}
}
/* retorna o cache mesmo VENCIDO (p/ stale-while-revalidate) */
function cacheGetStale(key){ try{ var s=JSON.parse(localStorage.getItem(key)); return (s&&s.d)?s.d:null; }catch(e){ return null; } }

/* ── JSONP ── */
function mcCall(route,params,cb){
  var cbName='_mc_cb_'+Date.now()+'_'+Math.random().toString(36).slice(2);
  var p={callback:cbName,key:MC_TOKEN,resource:route};
  if(params)Object.keys(params).forEach(function(k){p[k]=params[k];});
  var url=MC_API+'?'+Object.keys(p).map(function(k){return encodeURIComponent(k)+'='+encodeURIComponent(p[k]);}).join('&');
  var s=document.createElement('script');
  window[cbName]=function(d){try{delete window[cbName];}catch(e){}document.head.removeChild(s);cb(null,d);};
  s.src=url; s.onerror=function(){cb(new Error('net'));};
  document.head.appendChild(s);
  setTimeout(function(){if(window[cbName]){delete window[cbName];cb(new Error('timeout'));}},25000);
}

/* ── Formatação ── */
function fmtNum(v){
  v=Number(v)||0;
  if(v>=1000000)return(v/1000000).toFixed(1)+'M';
  if(v>=1000)return(v/1000).toFixed(1)+'K';
  return v.toString();
}
function fmtDate(iso){ // YYYY-MM-DD → DD/MM
  return iso.slice(8)+'/'+iso.slice(5,7);
}
function escH(s){return String(s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');}
function mediaIcon(t){if(!t)return'📷';t=t.toUpperCase();if(t==='VIDEO'||t==='REELS'||t==='REEL')return'🎬';return'📷';}
function mediaLabel(t){if(!t)return'Foto';t=t.toUpperCase();if(t==='VIDEO'||t==='REELS'||t==='REEL')return'Vídeo';return'Foto';}

/* ── Load Instagram (cache-first) ── */
function loadIG(forceRefresh){
  function apply(d,statusMsg){
    igData=d;
    igFollowerHistory=Array.isArray(d.follower_history)?d.follower_history:[];
    renderAccount(d);
    renderChart();
    if(statusMsg) setStatus(statusMsg);
    loadMedia(false);
  }
  // 1) cache fresco → usa e pronto (não rebusca)
  var cached=forceRefresh?null:cacheGet(cacheKey('account'));
  if(cached){ apply(cached,'Cache · '+new Date().toLocaleTimeString('pt-BR',{hour:'2-digit',minute:'2-digit'})); return; }
  // 2) cache VENCIDO → mostra na hora e atualiza em segundo plano (stale-while-revalidate)
  var stale=forceRefresh?null:cacheGetStale(cacheKey('account'));
  if(stale){ apply(stale,'Atualizando...'); }
  else setStatus('Buscando dados...');
  // 3) busca fresca (não bloqueia a exibição do stale)
  mcCall('social_instagram',{period:period},function(err,d){
    if(err||!d||d.error){
      if(stale){ setStatus('Cache · '+new Date().toLocaleTimeString('pt-BR',{hour:'2-digit',minute:'2-digit'})); return; } // mantém o stale
      setStatus('Erro ao carregar');
      document.getElementById('mcs-ig-kpis').innerHTML='<p style="padding:16px;color:var(--bad);font-size:11px">Erro na API do Instagram: '+(d&&d.error?d.error:(err?err.message:'desconhecido'))+'</p>';
      return;
    }
    cacheSave(cacheKey('account'),d,TTL_ACCOUNT);
    apply(d,'Atualizado '+new Date().toLocaleTimeString('pt-BR',{hour:'2-digit',minute:'2-digit'}));
  });
}

/* pré-carrega os períodos comuns em segundo plano → trocar de período fica
   instantâneo (vem do cache em vez de esperar a API) */
function prefetchPeriods(){
  var common=[7,30,90,9999];
  var savedPeriod=period;
  var i=0;
  (function next(){
    if(i>=common.length)return;
    var p=common[i++];
    if(p===savedPeriod){ next(); return; }   // o atual já foi buscado
    var key='mc_ig_account_'+p;
    var c=null; try{ var s=localStorage.getItem(key); if(s){var o=JSON.parse(s); if(o&&o.ts&&(Date.now()-o.ts)<TTL_ACCOUNT){ setTimeout(next,50); return; }} }catch(e){}
    mcCall('social_instagram',{period:p},function(err,d){
      if(!err&&d&&!d.error){ try{ localStorage.setItem(key,JSON.stringify({ts:Date.now(),ttl:TTL_ACCOUNT,d:d})); }catch(e){} }
      setTimeout(next,1200);   // espaça as chamadas pra não sobrecarregar o GAS
    });
  })();
}

function renderAccount(d){
  if(d.name)document.getElementById('mcs-ig-name').textContent=d.name;
  if(d.username)document.getElementById('mcs-ig-handle').textContent='@'+d.username;
  if(d.profile_picture_url)document.getElementById('mcs-ig-avatar').innerHTML='<img src="'+escH(d.profile_picture_url)+'" alt="avatar">';
  document.getElementById('mcs-ig-stats').innerHTML=[
    {val:fmtNum(d.followers_count||0),lbl:'Seguidores'},
    {val:fmtNum(d.follows_count||0),lbl:'Seguindo'},
    {val:fmtNum(d.media_count||0),lbl:'Posts'}
  ].map(function(s){return'<div class="mcs-account-stat"><span class="mcs-account-stat-val">'+s.val+'</span><span class="mcs-account-stat-lbl">'+s.lbl+'</span></div>';}).join('');
}

/* ── VIDEO e REELS são tratados como mesmo tipo ── */
function filteredMedia(){
  var sinceMs=Date.now()-period*86400000;
  return igMedia.filter(function(m){
    if(m.timestamp && new Date(m.timestamp).getTime()<sinceMs) return false; // só posts do período
    if(!mediaType) return true;
    var t=(m.media_type||'').toUpperCase();
    if(mediaType.toUpperCase()==='VIDEO') return t==='VIDEO'||t==='REELS'||t==='REEL';
    if(mediaType.toUpperCase()==='IMAGE') return t==='IMAGE'||t==='CAROUSEL_ALBUM';
    return t===mediaType.toUpperCase();
  });
}

function sortedMedia(){
  var items=filteredMedia().slice();
  if(mediaSort==='likes')    items.sort(function(a,b){return(b.like_count||0)-(a.like_count||0);});
  else if(mediaSort==='comments') items.sort(function(a,b){return(b.comments_count||0)-(a.comments_count||0);});
  else if(mediaSort==='views')    items.sort(function(a,b){return(b.reach||0)-(a.reach||0);});
  // 'recent': ordem do API (mais recente primeiro)
  return items;
}

function renderKpis(){
  if(!igData)return;
  var d=igData;
  var filtered=filteredMedia();
  var filtLikes=0,filtComments=0;
  filtered.forEach(function(m){filtLikes+=Number(m.like_count||0);filtComments+=Number(m.comments_count||0);});
  var followers=Number(d.followers_count||0);
  var engagements=filtLikes+filtComments;
  var engRate=followers>0&&engagements>0?((engagements/followers/period)*100).toFixed(2)+'%':'-';

  // Saldo do período: ganhos · perdidos = líquido
  var delta=d.follower_delta;
  var gained=d.follower_gained, lost=d.follower_lost;
  var segStr='';
  if(gained!=null) segStr+='<span class="mcs-kpi-good">+'+fmtNum(gained)+'</span>';
  if(lost!=null)   segStr+=(segStr?' · ':'')+'<span class="mcs-kpi-bad">-'+fmtNum(lost)+'</span>';
  if(delta!=null)  segStr+=(segStr?' = ':'')+'<span class="'+(delta>=0?'mcs-kpi-good':'mcs-kpi-bad')+'">'+(delta>=0?'+':'-')+fmtNum(Math.abs(delta))+'</span>';

  var lbl=mediaType?mediaLabel(mediaType):'no período';
  // Valor principal = total de seguidores (arredondado); hover mostra o total exato
  var kpis=[
    {lbl:'Seguidores',val:fmtNum(followers),subHtml:segStr||null,pop:followers.toLocaleString('pt-BR')+' seguidores'},
    {lbl:'Impressões',val:d.impressions?fmtNum(d.impressions):'N/D',raw:d.impressions||null,sub:'no período'},
    {lbl:'Alcance',val:d.reach?fmtNum(d.reach):'N/D',raw:d.reach||null,sub:'no período'},
    {lbl:'Visitas ao Perfil',val:d.profile_views?fmtNum(d.profile_views):'N/D',raw:d.profile_views||null,sub:'no período'},
    {lbl:'Curtidas',val:fmtNum(filtLikes),raw:filtLikes,sub:lbl},
    {lbl:'Comentários',val:fmtNum(filtComments),raw:filtComments,sub:lbl},
    {lbl:'Engajamento',val:engRate,raw:null,sub:'taxa média'},
    {lbl:'Posts',val:String(filtered.length),raw:filtered.length,sub:lbl}
  ];
  ensureSocialInlineCss();
  document.getElementById('mcs-ig-kpis').innerHTML=kpis.map(function(k){
    var tip=(!k.pop && k.raw!=null)?(' title="'+k.lbl+': '+k.raw.toLocaleString('pt-BR')+'"'):'';
    var subEl='';
    if(k.subHtml) subEl='<span class="mcs-kpi-sub">'+k.subHtml+'</span>';
    else if(k.sub) subEl='<span class="mcs-kpi-sub '+(k.subCls||'')+'">'+escH(k.sub)+'</span>';
    var pop=k.pop?'<span class="mcs-kpi-pop">'+escH(k.pop)+'</span>':'';
    return'<div class="mcs-kpi'+(k.pop?' mcs-has-pop':'')+'"'+tip+'><span class="mcs-kpi-lbl">'+k.lbl+'</span><span class="mcs-kpi-val">'+k.val+'</span>'+subEl+pop+'</div>';
  }).join('');
}
function ensureSocialInlineCss(){
  if(document.getElementById('mcs-inline-css'))return;
  var st=document.createElement('style');st.id='mcs-inline-css';
  st.textContent='.mcs-kpi.mcs-has-pop{position:relative;overflow:visible}'
    +'.mcs-kpi-pop{position:absolute;left:50%;bottom:calc(100% + 6px);transform:translateX(-50%) translateY(4px);background:var(--panel);border:1px solid var(--acc);color:var(--ink);padding:6px 10px;font-size:11px;font-weight:700;letter-spacing:.02em;white-space:nowrap;opacity:0;pointer-events:none;transition:opacity .18s ease,transform .18s ease;z-index:30;box-shadow:0 6px 18px rgba(0,0,0,.5)}'
    +'.mcs-kpi.mcs-has-pop:hover .mcs-kpi-pop{opacity:1;transform:translateX(-50%) translateY(0)}';
  document.head.appendChild(st);
}

/* ── Load media (cache-first) ── */
function loadMedia(forceRefresh){
  var MKEY='mc_ig_media_v1';
  var cached=forceRefresh?null:cacheGet(MKEY);
  if(cached&&Array.isArray(cached)){
    igMedia=cached;
    mediaPage=0;
    renderKpis();
    renderMedia();
    renderTopPosts();
    renderChart();
    return;
  }
  document.getElementById('mcs-ig-media').innerHTML='<p style="color:var(--mut);font-size:11px;text-transform:uppercase">Carregando posts...</p>';
  mcCall('social_ig_media',{limit:50},function(err,d){
    if(err||!d||d.error){
      document.getElementById('mcs-ig-media').innerHTML='<p style="color:var(--bad);font-size:11px">Erro ao carregar posts.</p>';
      renderKpis();
      renderChart();
      return;
    }
    igMedia=Array.isArray(d.data)?d.data:[];
    cacheSave(MKEY,igMedia,TTL_MEDIA);
    mediaPage=0;
    renderKpis();
    renderMedia();
    renderTopPosts();
    renderChart();
  });
}

/* ── Media grid com paginação ── */
function renderMedia(){
  var items=sortedMedia();
  var total=items.length;
  var totalPages=Math.ceil(total/MEDIA_PER_PAGE)||1;
  if(mediaPage>=totalPages)mediaPage=Math.max(0,totalPages-1);
  var page=items.slice(mediaPage*MEDIA_PER_PAGE,(mediaPage+1)*MEDIA_PER_PAGE);
  document.getElementById('mcs-ig-media-count').textContent=total+' posts';
  if(!page.length){
    document.getElementById('mcs-ig-media').innerHTML='<p style="color:var(--mut);font-size:11px">Nenhum post encontrado.</p>';
    document.getElementById('mcs-ig-pagination').innerHTML='';
    return;
  }
  document.getElementById('mcs-ig-media').innerHTML=page.map(function(m){
    var thumb=m.thumbnail_url||m.media_url;
    var thumbHtml=thumb?'<img class="mcs-media-thumb" src="'+escH(thumb)+'" alt="" loading="lazy">':'<div class="mcs-media-thumb-placeholder">'+mediaIcon(m.media_type)+'</div>';
    return'<div class="mcs-media-card" onclick="window.open(\''+escH(m.permalink||'#')+'\',\'_blank\')">'+thumbHtml
      +'<div class="mcs-media-body"><div class="mcs-media-type">'+mediaLabel(m.media_type)+'</div>'
      +'<div class="mcs-media-caption">'+escH((m.caption||'').slice(0,120))+'</div>'
      +'<div class="mcs-media-stats"><span class="mcs-media-stat">❤️ '+fmtNum(m.like_count||0)+'</span>'
      +'<span class="mcs-media-stat">💬 '+fmtNum(m.comments_count||0)+'</span></div>'
      +'</div></div>';
  }).join('');
  var pEl=document.getElementById('mcs-ig-pagination');
  if(totalPages>1){
    pEl.innerHTML='<div class="mcs-pagination">'
      +'<button class="mcs-page-btn"'+(mediaPage===0?' disabled':'')+' onclick="mcSocialPage('+(mediaPage-1)+')">← Anterior</button>'
      +'<span class="mcs-page-info">'+(mediaPage+1)+' / '+totalPages+'</span>'
      +'<button class="mcs-page-btn"'+(mediaPage>=totalPages-1?' disabled':'')+' onclick="mcSocialPage('+(mediaPage+1)+')">Próximo →</button>'
      +'</div>';
  } else { pEl.innerHTML=''; }
}

window.mcSocialPage=function(p){mediaPage=p;renderMedia();};

/* ── Top Posts ── */
function postScore(m){
  var eng=Number(m.like_count||0)+Number(m.comments_count||0)*2+Number(m.saved||0)*3+Number(m.shares||0)*2;
  if(m.reach&&Number(m.reach)>0) return eng/Number(m.reach)*10000;
  return eng;
}

function renderTopPosts(){
  ensureTopPostsCss();
  var src=filteredMedia();
  var top=src.slice().sort(function(a,b){return postScore(b)-postScore(a);}).slice(0,10);
  var host=document.getElementById('mcs-ig-top');
  if(!top.length){host.innerHTML='<p style="color:var(--mut);font-size:11px;text-transform:uppercase;letter-spacing:.06em;padding:12px 0">Nenhum post no período.</p>';return;}
  var n=src.length||1;
  var avg=function(f){return src.reduce(function(s,m){return s+(Number(f(m))||0);},0)/n;};
  var avgLikes=avg(function(m){return m.like_count;});
  var avgComments=avg(function(m){return m.comments_count;});
  var wR=src.filter(function(m){return m.reach!=null;});
  var avgReach=wR.length?wR.reduce(function(s,m){return s+Number(m.reach||0);},0)/wR.length:0;
  var wS=src.filter(function(m){return m.saved!=null;});
  var avgSaved=wS.length?wS.reduce(function(s,m){return s+Number(m.saved||0);},0)/wS.length:0;
  var maxScore=postScore(top[0])||1;

  function vsAvg(val,avr){
    if(!avr||val==null)return'<span style="color:var(--mut)">—</span>';
    var p=Math.round((val-avr)/avr*100);
    return p>=0?'<span class="mcs-kpi-good">▲ +'+p+'%</span>':'<span class="mcs-kpi-bad">▼ '+p+'%</span>';
  }
  function pctR(val,reach){ if(!reach||val==null)return'—'; return((Number(val)/Number(reach))*100).toFixed(1)+'%'; }
  function stat(ic,val,lbl){ return '<div class="mcs-tp-stat" title="'+lbl+'"><span class="mcs-tp-stat-ic">'+ic+'</span><span class="mcs-tp-stat-v">'+val+'</span></div>'; }

  host.innerHTML='<div class="mcs-tp-grid">'+top.map(function(m,i){
    var score=postScore(m);
    var pct=Math.max(4,Math.round(score/maxScore*100));
    var likes=Number(m.like_count||0),comments=Number(m.comments_count||0);
    var reach=m.reach!=null?Number(m.reach):null;
    var saved=m.saved!=null?Number(m.saved):null;
    var shares=m.shares!=null?Number(m.shares):null;
    var eng=likes+comments+(saved||0)+(shares||0);
    var engRate=reach?((eng/reach)*100).toFixed(1)+'%':null;
    var thumb=m.thumbnail_url||m.media_url;
    var thumbHtml=thumb?'<img src="'+escH(thumb)+'" alt="" loading="lazy">':'<div class="mcs-tp-ph">'+mediaIcon(m.media_type)+'</div>';
    var link=m.permalink?escH(m.permalink):null;
    var pid='mcs-tp-'+i;
    var rankCls=i<3?' r'+(i+1):'';
    var rows='<tr><td>❤️ Curtidas</td><td>'+fmtNum(likes)+'</td><td>'+vsAvg(likes,avgLikes)+'</td><td>'+pctR(likes,reach)+'</td></tr>'
      +'<tr><td>💬 Comentários</td><td>'+fmtNum(comments)+'</td><td>'+vsAvg(comments,avgComments)+'</td><td>'+pctR(comments,reach)+'</td></tr>'
      +(reach!=null?'<tr><td>👁 Alcance</td><td>'+fmtNum(reach)+'</td><td>'+vsAvg(reach,avgReach)+'</td><td>—</td></tr>':'')
      +(saved!=null?'<tr><td>🔖 Saves</td><td>'+fmtNum(saved)+'</td><td>'+vsAvg(saved,avgSaved)+'</td><td>'+pctR(saved,reach)+'</td></tr>':'')
      +(shares!=null?'<tr><td>📤 Shares</td><td>'+fmtNum(shares)+'</td><td>—</td><td>'+pctR(shares,reach)+'</td></tr>':'')
      +(engRate?'<tr><td>⚡ Engajamento</td><td>'+engRate+'</td><td>—</td><td>—</td></tr>':'');
    return '<div class="mcs-tp-card'+rankCls+'" id="'+pid+'-card" style="animation-delay:'+(i*0.045).toFixed(3)+'s">'
      +'<div class="mcs-tp-media" onclick="mcSocialTogglePost(\''+pid+'\')">'
        +thumbHtml
        +'<span class="mcs-tp-rank">'+(i+1)+'</span>'
        +(m.media_type?'<span class="mcs-tp-badge">'+mediaIcon(m.media_type)+'</span>':'')
      +'</div>'
      +'<div class="mcs-tp-body">'
        +'<div class="mcs-tp-cap" onclick="mcSocialTogglePost(\''+pid+'\')">'+escH((m.caption||'Sem legenda').replace(/\s+/g,' ').slice(0,90))+'</div>'
        +'<div class="mcs-tp-stats">'
          +stat('❤️',fmtNum(likes),'Curtidas')
          +stat('💬',fmtNum(comments),'Comentários')
          +(reach!=null?stat('👁',fmtNum(reach),'Alcance'):'')
          +(saved!=null?stat('🔖',fmtNum(saved),'Saves'):'')
          +(engRate?stat('⚡',engRate,'Taxa de engajamento'):'')
        +'</div>'
        +'<div class="mcs-tp-barrow">'
          +'<div class="mcs-tp-bar"><i style="--p:'+(pct/100).toFixed(3)+'"></i></div>'
          +'<button class="mcs-tp-toggle" onclick="mcSocialTogglePost(\''+pid+'\')">Detalhes <span class="mcs-tp-caret" id="'+pid+'-caret">▾</span></button>'
          +(link?'<a class="mcs-tp-open" href="'+link+'" target="_blank" rel="noopener" title="Abrir no Instagram">↗</a>':'')
        +'</div>'
        +'<div class="mcs-tp-detail" id="'+pid+'">'
          +'<table class="mcs-detail-table"><thead><tr><th>Métrica</th><th>Total</th><th>vs Média</th><th>% Alcance</th></tr></thead><tbody>'+rows+'</tbody></table>'
        +'</div>'
      +'</div>'
    +'</div>';
  }).join('')+'</div>';
}

window.mcSocialTogglePost=function(id){
  var card=document.getElementById(id+'-card');
  var caret=document.getElementById(id+'-caret');
  if(!card)return;
  var open=card.classList.toggle('open');
  if(caret)caret.textContent=open?'▴':'▾';
};

function ensureTopPostsCss(){
  if(document.getElementById('mcs-tp-css'))return;
  var s=document.createElement('style');s.id='mcs-tp-css';
  s.textContent=[
   '.mcs-tp-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(340px,1fr));gap:12px}',
   '.mcs-tp-card{display:flex;flex-direction:column;background:var(--panel);border:1px solid var(--line);overflow:hidden;opacity:0;transform:translateY(10px);animation:mcs-tp-in .5s cubic-bezier(.2,.9,.3,1) forwards}',
   '@keyframes mcs-tp-in{to{opacity:1;transform:translateY(0)}}',
   '.mcs-tp-card{transition:border-color .18s ease,transform .18s ease,box-shadow .18s ease}',
   '.mcs-tp-card:hover{border-color:var(--acc);transform:translateY(-2px);box-shadow:0 8px 24px rgba(0,0,0,.4)}',
   '.mcs-tp-card.r1{border-color:var(--acc);box-shadow:0 0 0 1px var(--acc),0 8px 26px rgba(255,242,0,.1)}',
   '.mcs-tp-card{flex-direction:row}',
   '.mcs-tp-media{position:relative;flex:0 0 96px;width:96px;cursor:pointer;overflow:hidden;background:var(--line2)}',
   '.mcs-tp-media img{width:100%;height:100%;object-fit:cover;display:block;transition:transform .35s ease}',
   '.mcs-tp-card:hover .mcs-tp-media img{transform:scale(1.06)}',
   '.mcs-tp-ph{width:100%;height:100%;display:flex;align-items:center;justify-content:center;font-size:26px}',
   '.mcs-tp-rank{position:absolute;top:6px;left:6px;min-width:20px;height:20px;padding:0 5px;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,.7);color:#fff;font-size:11px;font-weight:800;border-radius:2px;font-family:var(--mono)}',
   '.mcs-tp-card.r1 .mcs-tp-rank{background:var(--acc);color:#000}',
   '.mcs-tp-badge{position:absolute;bottom:6px;right:6px;font-size:11px;background:rgba(0,0,0,.6);padding:1px 4px;border-radius:2px}',
   '.mcs-tp-body{flex:1;min-width:0;display:flex;flex-direction:column;gap:8px;padding:10px 12px}',
   '.mcs-tp-cap{font-size:11px;line-height:1.4;color:var(--ink);cursor:pointer;overflow:hidden;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}',
   '.mcs-tp-stats{display:flex;flex-wrap:wrap;gap:6px}',
   '.mcs-tp-stat{display:inline-flex;align-items:center;gap:4px;background:var(--bg);border:1px solid rgba(255,255,255,.08);padding:3px 7px;font-size:10px;color:#b5b5b5}',
   '.mcs-tp-stat-ic{font-size:10px}',
   '.mcs-tp-stat-v{font-weight:700;color:var(--ink)}',
   '.mcs-tp-barrow{display:flex;align-items:center;gap:10px}',
   '.mcs-tp-bar{flex:1;height:5px;background:var(--line2);overflow:hidden}',
   '.mcs-tp-bar i{display:block;height:100%;background:linear-gradient(90deg,var(--acc),#c9c000);transform-origin:left;transform:scaleX(var(--p));animation:mcs-tp-grow .85s cubic-bezier(.2,.9,.3,1) both}',
   '@keyframes mcs-tp-grow{from{transform:scaleX(0)}to{transform:scaleX(var(--p))}}',
   '.mcs-tp-toggle{background:none;border:none;color:#b5b5b5;font-family:inherit;font-size:10px;text-transform:uppercase;letter-spacing:.05em;cursor:pointer;white-space:nowrap;display:inline-flex;align-items:center;gap:4px}',
   '.mcs-tp-toggle:hover{color:var(--acc)}',
   '.mcs-tp-caret{transition:transform .2s ease}',
   '.mcs-tp-open{color:#b5b5b5;text-decoration:none;font-size:13px;line-height:1}',
   '.mcs-tp-open:hover{color:var(--acc)}',
   '.mcs-tp-detail{max-height:0;opacity:0;overflow:hidden;transition:max-height .35s cubic-bezier(.4,0,.2,1),opacity .3s ease}',
   '.mcs-tp-card.open .mcs-tp-detail{max-height:260px;opacity:1}',
   '.mcs-tp-detail .mcs-detail-table{margin-top:4px}',
   '@media(max-width:520px){.mcs-tp-grid{grid-template-columns:1fr}}'
  ].join('');
  document.head.appendChild(s);
}

/* ══════════════════════════════════════════════════════════
   CCC · Ranking dos Carros Mais Votados
   Fonte: worker de votos (mesma da página CCC / planilha "votes").
   Catálogo (fotos/modelo/insta) espelhado de ccc-lancamento/ccc.html —
   mantenha em sincronia ao adicionar/remover carros na página CCC.
   ══════════════════════════════════════════════════════════ */
var CCC_VOTES_URL='https://script.google.com/macros/s/AKfycbxGPiBekdzdOc3eT4nVkLkMPhwVQA88WdyLIrbxZLY05qfVdrku1iV8pvGM49NbjlpH/exec'; // /exec do Apps Script de votos — leitura do acumulado (stats_all)
var CCC_CARS=[
  {id:"swift-95", model:"Swift '95", insta:"@swift.gaijin", href:"https://www.instagram.com/swift.gaijin", photo:"https://cdn.shopify.com/s/files/1/0719/0174/1228/files/c8.png?v=1783964946"},
  {id:"impreza-2011", model:"Impreza WRX 2011", insta:"@snoopywrx", href:"https://www.instagram.com/snoopywrxx", photo:"https://cdn.shopify.com/s/files/1/0719/0174/1228/files/c1.png?v=1783964946"},
  {id:"sandero-2017", model:"Sandero RS 2017", insta:"@pluccgarage", href:"https://instagram.com/pluccgarage", photo:"https://cdn.shopify.com/s/files/1/0719/0174/1228/files/c2.png?v=1783964946"},
  {id:"chevette-93", model:"Chevette SL '93", insta:"@h0lnik.ls", href:"https://instagram.com/h0lnik.ls", photo:"https://cdn.shopify.com/s/files/1/0719/0174/1228/files/c3.png?v=1783964946"},
  {id:"bora-2006", model:"Bora MK3 2006", insta:"@ald0_jrr6", href:"https://instagram.com/ald0_jrr", photo:"https://cdn.shopify.com/s/files/1/0719/0174/1228/files/c4.png?v=1783964946"},
  {id:"corolla-2006", model:"Corolla XEI 2006", insta:"@silvanogarage", href:"https://instagram.com/silvanogarage", photo:"https://cdn.shopify.com/s/files/1/0719/0174/1228/files/c5.png?v=1783964946"},
  {id:"kadett-97", model:"Kadett GL '97", insta:"@itens_de_vrine", href:"https://www.instagram.com/Itens_de_vrine", photo:"https://cdn.shopify.com/s/files/1/0719/0174/1228/files/c6.png?v=1783964946"},
  {id:"e36-95", model:"BMW E36 '95", insta:"@yuriiii._._", href:"https://www.instagram.com/yuriiii._._", photo:"https://cdn.shopify.com/s/files/1/0719/0174/1228/files/c7.png?v=1783964947"},
  {id:"fit-2007", model:"Fit 2007", insta:"@_picodograu", href:"https://instagram.com/_picodograu", photo:"https://cdn.shopify.com/s/files/1/0719/0174/1228/files/c9.png?v=1783965816"},
  {id:"civic-2008", model:"Civic 2008", insta:"@czr_garage027", href:"https://www.instagram.com/czr_garage027", photo:"https://cdn.shopify.com/s/files/1/0719/0174/1228/files/civic2008.jpg?v=1784065933"},
  {id:"chevette-85", model:"Chevette SL '85", insta:"@robson_cantele", href:"https://www.instagram.com/robson_cantele", photo:"https://cdn.shopify.com/s/files/1/0719/0174/1228/files/chevette2.jpg?v=1784065933"},
  {id:"sportage-96", model:"Sportage '96", insta:"@bryan_vanzo", href:"https://www.instagram.com/bryan_vanzo", photo:"https://cdn.shopify.com/s/files/1/0719/0174/1228/files/sportage.jpg?v=1784066527"},
  {id:"corsa-95", model:"Corsa '95", insta:"@david_agro01", href:"https://www.instagram.com/david_agro01", photo:"https://cdn.shopify.com/s/files/1/0719/0174/1228/files/corsa.jpg?v=1784066527"},
  {id:"astra-2009", model:"Astra 2009", insta:"@santt_zwx", href:"https://www.instagram.com/santt_zwx", photo:"https://cdn.shopify.com/s/files/1/0719/0174/1228/files/astra.jpg?v=1784151573"},
  {id:"m2-2017", model:"BMW M2 2017", insta:"@mantiqueira_tougue_storm", href:"https://www.instagram.com/mantiqueira_tougue_storm", photo:"https://cdn.shopify.com/s/files/1/0719/0174/1228/files/m2.png?v=1784151575"},
  {id:"yaris-2019", model:"Yaris XLS 2019", insta:"@jpr.garage", href:"https://www.instagram.com/jpr.garage", photo:"https://cdn.shopify.com/s/files/1/0719/0174/1228/files/yaris.jpg?v=1784151574"},
  {id:"clio-2000", model:"Clio 2000", insta:"@ph_deda", href:"https://www.instagram.com/ph_deda", photo:"https://cdn.shopify.com/s/files/1/0719/0174/1228/files/clio.jpg?v=1784151574"},
  {id:"civic-96", model:"Civic EJ9 '96", insta:"@akhkharu_cars", href:"https://www.instagram.com/akhkharu_cars", photo:"https://cdn.shopify.com/s/files/1/0719/0174/1228/files/civic96.jpg?v=1784203328"},
  {id:"320i-2024", model:"BMW 320I M Sport 2024", insta:"@garage019_blue", href:"https://www.instagram.com/garage019_blue", photo:"https://cdn.shopify.com/s/files/1/0719/0174/1228/files/320i.png?v=1784203786"},
  {id:"civic-99", model:"Civic EX '99", insta:"@civigod_00", href:"https://www.instagram.com/civigod_00", photo:"https://cdn.shopify.com/s/files/1/0719/0174/1228/files/civic99.png?v=1784427998"},
  {id:"civic-99-2", model:"Civic EX '99", insta:"@angel.civic_", href:"https://www.instagram.com/angel.civic_", photo:"https://cdn.shopify.com/s/files/1/0719/0174/1228/files/civic992.png?v=1784427998"},
  {id:"polo-2018", model:"Polo Highline 2018", insta:"@william.cost4_", href:"https://www.instagram.com/william.cost4_", photo:"https://cdn.shopify.com/s/files/1/0719/0174/1228/files/polo.png?v=1784427998"},
  {id:"fusion-2008", model:"Fusion 2008", insta:"@its_gehrke", href:"https://www.instagram.com/its_gehrke", photo:"https://cdn.shopify.com/s/files/1/0719/0174/1228/files/fusion.png?v=1784611813"},
  {id:"lancer-97", model:"Lancer '97", insta:"@garage.com.ii", href:"https://www.instagram.com/garage.com.ii", photo:"https://cdn.shopify.com/s/files/1/0719/0174/1228/files/lancer.png?v=1784611958"},
  {id:"beetle-2013", model:"Beetle 2013", insta:"", href:"", photo:"https://cdn.shopify.com/s/files/1/0719/0174/1228/files/beetle.png?v=1784611813"},
  {id:"fluence-2013", model:"Fluence 2013", insta:"@natasha._.kstnk", href:"https://www.instagram.com/natasha._.kstnk", photo:"https://cdn.shopify.com/s/files/1/0719/0174/1228/files/fluence.png?v=1784611813"},
  {id:"328", model:"BMW 328", insta:"@jeffersommenezs", href:"https://www.instagram.com/jeffersommenezs", photo:"https://cdn.shopify.com/s/files/1/0719/0174/1228/files/328.png?v=1784611813"},
  {id:"e36-93", model:"BMW E36 '93", insta:"@giliardpamplona", href:"https://www.instagram.com/giliardpamplona", photo:"https://cdn.shopify.com/s/files/1/0719/0174/1228/files/e36.png?v=1784612296"},
  {id:"308-2014", model:"Peugeot 308 2014", insta:"@omarcelovm", href:"https://www.instagram.com/omarcelovm", photo:"https://cdn.shopify.com/s/files/1/0719/0174/1228/files/308.png?v=1784550941"}
];

function injectCccStyles(){
  if(document.getElementById('mcs-ccc-style'))return;
  var s=document.createElement('style');
  s.id='mcs-ccc-style';
  s.textContent=
    '#mcs-ccc-ranking{margin-top:8px;margin-bottom:28px}'
   +'.mcs-ccc-panel{background:var(--panel);border:1px solid var(--line);padding:18px 18px 20px}'
   +'.mcs-ccc-total{font-size:10px;background:var(--acc);color:#000;font-weight:700;padding:2px 9px;border-radius:10px;letter-spacing:.04em}'
   /* pódio */
   +'.mcs-ccc-podium{display:grid;grid-template-columns:1fr 1.25fr 1fr;gap:12px;align-items:end;margin-bottom:22px}'
   +'.mcs-ccc-pod{position:relative;background:var(--bg);border:1px solid var(--line2);overflow:hidden;transition:transform .18s,border-color .18s;cursor:pointer;text-decoration:none;color:var(--ink);display:block}'
   +'.mcs-ccc-pod:hover{transform:translateY(-3px);border-color:var(--acc)}'
   +'.mcs-ccc-pod.r1{border-color:var(--acc);box-shadow:0 0 0 1px var(--acc),0 8px 26px rgba(255,242,0,.12)}'
   +'.mcs-ccc-pod-photo{position:relative;width:100%;aspect-ratio:3/2;background:var(--line2);overflow:hidden}'
   +'.mcs-ccc-pod-photo img{width:100%;height:100%;object-fit:cover;display:block}'
   +'.mcs-ccc-pod.r1 .mcs-ccc-pod-photo{aspect-ratio:4/3}'
   +'.mcs-ccc-medal{position:absolute;top:8px;left:8px;width:30px;height:30px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:14px;font-weight:800;font-family:var(--mono);color:#000;box-shadow:0 2px 8px rgba(0,0,0,.5);z-index:2}'
   +'.mcs-ccc-medal.m1{background:linear-gradient(135deg,#ffe259,#ffa751)}'
   +'.mcs-ccc-medal.m2{background:linear-gradient(135deg,#e0e0e0,#9fa4ad)}'
   +'.mcs-ccc-medal.m3{background:linear-gradient(135deg,#e0a46b,#b06a34);color:#1a1a1a}'
   +'.mcs-ccc-pod-body{padding:10px 12px 12px}'
   +'.mcs-ccc-pod-model{font-size:12px;font-weight:700;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}'
   +'.mcs-ccc-pod.r1 .mcs-ccc-pod-model{font-size:14px}'
   +'.mcs-ccc-pod-insta{font-size:10px;color:var(--mut);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;margin-top:1px}'
   +'.mcs-ccc-pod-votes{display:flex;align-items:baseline;gap:5px;margin-top:8px}'
   +'.mcs-ccc-pod-votes b{font-size:20px;font-weight:800;color:var(--acc);line-height:1}'
   +'.mcs-ccc-pod.r1 .mcs-ccc-pod-votes b{font-size:26px}'
   +'.mcs-ccc-pod-votes span{font-size:9px;text-transform:uppercase;letter-spacing:.08em;color:var(--mut)}'
   +'.mcs-ccc-pod-plat{height:5px;background:var(--line2)}'
   +'.mcs-ccc-pod.r1 .mcs-ccc-pod-plat{background:var(--acc)}'
   +'.mcs-ccc-pod.r2 .mcs-ccc-pod-plat{background:#9fa4ad}'
   +'.mcs-ccc-pod.r3 .mcs-ccc-pod-plat{background:#b06a34}'
   /* lista de barras */
   +'.mcs-ccc-list{display:flex;flex-direction:column;gap:2px}'
   +'.mcs-ccc-row{display:flex;align-items:center;gap:12px;padding:9px 6px;border-bottom:1px solid var(--line);text-decoration:none;color:var(--ink);transition:background .15s}'
   +'.mcs-ccc-row:last-child{border-bottom:none}'
   +'.mcs-ccc-row:hover{background:rgba(255,255,255,.03)}'
   +'.mcs-ccc-rk{font-size:12px;font-weight:700;color:var(--mut);flex:0 0 26px;text-align:center}'
   +'.mcs-ccc-thumb{width:46px;height:34px;background:var(--line2);flex:0 0 46px;overflow:hidden;display:block}'
   +'.mcs-ccc-thumb img{width:100%;height:100%;object-fit:cover;display:block}'
   +'.mcs-ccc-noimg{width:100%;height:100%;display:flex;align-items:center;justify-content:center;background:var(--line2);color:var(--mut);font-weight:700}'
   +'.mcs-ccc-pod-photo .mcs-ccc-noimg{font-size:26px}'
   +'.mcs-ccc-thumb .mcs-ccc-noimg{font-size:11px}'
   +'.mcs-ccc-mid{flex:1;min-width:0}'
   +'.mcs-ccc-name{display:flex;align-items:baseline;gap:8px;margin-bottom:5px}'
   +'.mcs-ccc-name b{font-size:12px;font-weight:700;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}'
   +'.mcs-ccc-name i{font-size:10px;color:var(--mut);font-style:normal;white-space:nowrap;flex:0 0 auto}'
   +'.mcs-ccc-delta{flex:0 0 auto;font-family:var(--mono);font-size:10px;font-weight:700;min-width:26px;text-align:center;letter-spacing:-.02em}'
   +'.mcs-ccc-delta.up{color:#48f91e}'
   +'.mcs-ccc-delta.down{color:#ff4d4d}'
   +'.mcs-ccc-delta.same{color:var(--mut);opacity:.5}'
   +'.mcs-ccc-barwrap{height:6px;background:var(--line2);border-radius:0;overflow:hidden}'
   +'.mcs-ccc-bar{height:100%;background:linear-gradient(90deg,var(--acc),#e6da00);border-radius:0;transition:width .6s cubic-bezier(.22,.61,.36,1)}'
   +'.mcs-ccc-vt{flex:0 0 auto;text-align:right;min-width:56px}'
   +'.mcs-ccc-vt b{font-size:15px;font-weight:800;display:block;line-height:1}'
   +'.mcs-ccc-vt span{font-size:8px;text-transform:uppercase;letter-spacing:.06em;color:var(--mut)}'
   +'.mcs-ccc-empty{padding:26px;text-align:center;color:var(--mut);font-size:11px;text-transform:uppercase;letter-spacing:.06em}'
   /* entrada suave escalonada */
   +'@keyframes mcs-ccc-in{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:translateY(0)}}'
   +'.mcs-ccc-pod{animation:mcs-ccc-in .55s cubic-bezier(.2,.9,.3,1) both}'
   +'.mcs-ccc-pod.r2{animation-delay:.04s}.mcs-ccc-pod.r1{animation-delay:.12s}.mcs-ccc-pod.r3{animation-delay:.2s}'
   +'.mcs-ccc-row{animation:mcs-ccc-in .45s ease both}'
   +'.mcs-ccc-row:nth-child(1){animation-delay:.02s}.mcs-ccc-row:nth-child(2){animation-delay:.06s}.mcs-ccc-row:nth-child(3){animation-delay:.1s}.mcs-ccc-row:nth-child(4){animation-delay:.14s}.mcs-ccc-row:nth-child(5){animation-delay:.18s}.mcs-ccc-row:nth-child(6){animation-delay:.22s}.mcs-ccc-row:nth-child(7){animation-delay:.26s}.mcs-ccc-row:nth-child(8){animation-delay:.3s}.mcs-ccc-row:nth-child(n+9){animation-delay:.34s}'
   +'@media(max-width:600px){.mcs-ccc-podium{grid-template-columns:1fr 1fr;gap:8px}.mcs-ccc-pod.r1{grid-column:span 2}.mcs-ccc-pod.r1 .mcs-ccc-pod-photo{aspect-ratio:16/9}}';
  document.head.appendChild(s);
}

/* Garante que o container exista; se o HTML não tiver, injeta antes do "Top Posts". */
function cccEnsureContainer(){
  var box=document.getElementById('mcs-ccc-ranking');
  if(box)return box;
  var root=document.getElementById('mcs-tab-instagram');
  if(!root)return null;
  // Localiza o cabeçalho "Top Posts por Engajamento" para inserir logo acima
  var anchor=null;
  var heads=root.querySelectorAll('.mcs-section-head');
  Array.prototype.forEach.call(heads,function(h){
    if(!anchor && /top posts/i.test(h.textContent||''))anchor=h;
  });
  box=document.createElement('div');
  box.id='mcs-ccc-ranking';
  if(anchor)root.insertBefore(box,anchor);
  else root.appendChild(box);
  return box;
}

function cccPhoto(car){
  if(car.photo) return '<img src="'+escH(car.photo)+'" alt="'+escH(car.model)+'" loading="lazy">';
  return '<div class="mcs-ccc-noimg">'+escH(String(car.model||'?').replace(/[^A-Za-z0-9]/g,'').slice(0,2).toUpperCase()||'?')+'</div>';
}
function renderCccRanking(data,meta){
  var box=cccEnsureContainer();
  if(!box)return;
  data=data||{};
  var counts=data.counts||{}, models=data.models||{};
  var catalog={};
  CCC_CARS.forEach(function(c){catalog[c.id]=c;});
  var ids={};
  Object.keys(counts).forEach(function(k){if(k)ids[k]=1;});
  CCC_CARS.forEach(function(c){ids[c.id]=1;});
  var cars=Object.keys(ids).map(function(id){
    var bs=catalog[id];
    var car=bs?{id:bs.id,model:bs.model,insta:bs.insta,href:bs.href,photo:bs.photo}
              :{id:id,model:(models[id]||id),insta:'',href:'',photo:''};
    return {car:car,votes:Number(counts[id]||0)};
  });
  var totalVotes=cars.reduce(function(s,x){return s+x.votes;},0);
  cars.sort(function(a,b){return b.votes-a.votes || String(a.car.model).localeCompare(String(b.car.model));});
  var maxV=cars.length?Math.max(1,cars[0].votes):1;

  /* ANTI-PISCA: se os votos não mudaram desde o último render, não reconstrói
     o DOM (era o "sumindo e voltando" a cada refresh de 15s) */
  var sig=cars.map(function(x){return x.car.id+':'+x.votes;}).join('|');
  if(sig===_cccSig && box.querySelector('.mcs-ccc-panel')) return;

  /* setinhas de posição: ranking de ONTEM calculado no SERVIDOR a partir das
     datas dos votos (counts_prev = votos com data anterior a hoje). Fallback:
     base intradiária no localStorage enquanto não houver votos de dias anteriores. */
  var dt=new Date();
  var todayStr=dt.getFullYear()+'-'+('0'+(dt.getMonth()+1)).slice(-2)+'-'+('0'+dt.getDate()).slice(-2);
  var newRank={}; cars.forEach(function(x,i){newRank[x.car.id]=i;});
  var prevRanks=null, baseTxt='ontem';
  var countsPrev=data.counts_prev;
  var prevSum=countsPrev?Object.keys(countsPrev).reduce(function(s,k){return s+(Number(countsPrev[k])||0);},0):0;
  if(countsPrev && prevSum>0){
    var prevCars=cars.map(function(x){return {id:x.car.id,model:x.car.model,votes:Number(countsPrev[x.car.id]||0)};});
    prevCars.sort(function(a,b){return b.votes-a.votes || String(a.model).localeCompare(String(b.model));});
    prevRanks={}; prevCars.forEach(function(x,i){prevRanks[x.id]=i;});
  } else {
    // sem votos de dias anteriores ainda → base intradiária (1ª leitura do dia)
    var cccHist={}; try{ cccHist=JSON.parse(localStorage.getItem('mc_ccc_hist')||'{}')||{}; }catch(e){}
    prevRanks=cccHist['base@'+todayStr]||null; baseTxt='a base de hoje';
    var keepB={}; keepB['base@'+todayStr]=prevRanks||newRank;
    try{ localStorage.setItem('mc_ccc_hist',JSON.stringify(keepB)); }catch(e){}
  }
  function ccArrow(id){
    var prev=prevRanks?prevRanks[id]:null;
    if(prev==null) return '<span class="mcs-ccc-delta same" title="sem base ainda">–</span>';
    var d=prev-newRank[id];
    if(d>0) return '<span class="mcs-ccc-delta up" title="subiu '+d+' desde '+baseTxt+'">▲'+d+'</span>';
    if(d<0) return '<span class="mcs-ccc-delta down" title="desceu '+(-d)+' desde '+baseTxt+'">▼'+(-d)+'</span>';
    return '<span class="mcs-ccc-delta same" title="mesma posição desde '+baseTxt+'">–</span>';
  }

  var head='<div class="mcs-section-head"><h2>🏁 Carros Mais Votados · CCC</h2>'
    +'<span class="mcs-ccc-total">'+fmtNum(totalVotes)+' votos</span></div>';

  if(!totalVotes){
    var diagHtml='';
    if(meta&&(meta.diag||meta.sheets||meta.columns)){
      var dp=[];
      if(meta.diag)dp.push(escH(String(meta.diag)));
      if(meta.sheets)dp.push('abas: '+escH(meta.sheets.join(', ')));
      if(meta.columns)dp.push('colunas: '+escH(meta.columns.join(', ')));
      diagHtml='<div style="margin-top:8px;font-size:10px;color:var(--warn);text-transform:none;letter-spacing:0;line-height:1.5">'+dp.join(' · ')+'</div>';
    }
    box.innerHTML=head+'<div class="mcs-ccc-panel"><div class="mcs-ccc-empty">Ainda não há votos registrados'+diagHtml+'</div></div>';
    return;
  }

  var top3=cars.slice(0,3);
  var podOrder=[top3[1],top3[0],top3[2]];
  var podium=podOrder.map(function(x,idx){
    if(!x)return'';
    var rank=(idx===1)?1:(idx===0?2:3);
    var pct=Math.round(x.votes/maxV*100);
    var op=x.car.href?('<a class="mcs-ccc-pod r'+rank+'" href="'+escH(x.car.href)+'" target="_blank" rel="noopener"'):('<div class="mcs-ccc-pod r'+rank+'"');
    var cl=x.car.href?'</a>':'</div>';
    return op+' title="'+escH(x.car.model)+'">'
      +'<div class="mcs-ccc-pod-photo"><span class="mcs-ccc-medal m'+rank+'">'+rank+'</span>'+cccPhoto(x.car)+'</div>'
      +'<div class="mcs-ccc-pod-body">'
      +'<div class="mcs-ccc-pod-model">'+escH(x.car.model)+'</div>'
      +'<span class="mcs-ccc-pod-insta">'+escH(x.car.insta||'')+'</span>'
      +'<div class="mcs-ccc-pod-votes"><b>'+fmtNum(x.votes)+'</b><span>votos</span></div>'
      +'</div><div class="mcs-ccc-pod-plat" style="height:'+(4+pct/12)+'px"></div>'+cl;
  }).join('');

  var list=cars.map(function(x,i){
    var pct=Math.round(x.votes/maxV*100);
    var op=x.car.href?('<a class="mcs-ccc-row" href="'+escH(x.car.href)+'" target="_blank" rel="noopener">'):'<div class="mcs-ccc-row">';
    var cl=x.car.href?'</a>':'</div>';
    return op
      +'<span class="mcs-ccc-rk">'+(i+1)+'</span>'
      +ccArrow(x.car.id)
      +'<span class="mcs-ccc-thumb">'+cccPhoto(x.car)+'</span>'
      +'<div class="mcs-ccc-mid"><div class="mcs-ccc-name"><b>'+escH(x.car.model)+'</b><i>'+escH(x.car.insta||'')+'</i></div>'
      +'<div class="mcs-ccc-barwrap"><div class="mcs-ccc-bar" style="width:'+pct+'%"></div></div></div>'
      +'<div class="mcs-ccc-vt"><b>'+fmtNum(x.votes)+'</b><span>votos</span></div>'
      +cl;
  }).join('');

  box.innerHTML=head+'<div class="mcs-ccc-panel"><div class="mcs-ccc-podium">'+podium+'</div><div class="mcs-ccc-list">'+list+'</div></div>';
  _cccSig=sig;
}
var _cccPrevRank=null, _cccSig='';

function loadCccVotes(force){
  injectCccStyles();
  var box=cccEnsureContainer();
  if(box && !box.innerHTML){
    box.innerHTML='<div class="mcs-section-head"><h2>🏁 Carros Mais Votados · CCC</h2></div>'
      +'<div class="mcs-ccc-panel"><div class="mcs-ccc-empty">Carregando votos...</div></div>';
  }
  // Cache curto (2 min) para não recarregar a cada render — o refresh
  // automático (tempo real) passa force=true e vai direto no servidor
  var cached=force?null:cacheGet('mc_ccc_votes');
  if(cached){renderCccRanking(cached);return;}
  // Total ACUMULADO (todos os votos) via worker → ação 'stats_all' no Apps Script de votos
  fetch(CCC_VOTES_URL,{
    method:'POST',
    headers:{'Content-Type':'text/plain;charset=utf-8'},
    body:JSON.stringify({action:'stats_all'})
  }).then(function(r){return r.json();}).then(function(res){
    if(!res||res.error){renderCccRanking({},{diag:(res&&res.error)||'sem dados'});return;}
    var payload={counts:res.counts||{},models:res.models||{},counts_prev:res.counts_prev||null};
    cacheSave('mc_ccc_votes',payload,2*60*1000);
    renderCccRanking(payload,{diag:null});
  }).catch(function(){
    renderCccRanking({},{diag:'falha ao buscar votos'});
  });
}

/* ── Gráfico de seguidores ── */
var chartShowLost=false;  /* padrão: saldo diário. Ligar mostra Ganho × Perdidos */
/* renderiza os DOIS gráficos lado a lado: saldo diário + total de seguidores */
function renderChart(){
  ensureChartCss();
  // botão "Perdidos" (toggle) no cabeçalho do gráfico diário
  var dhead=document.getElementById('mcs-chart-daily-head');
  if(dhead&&!document.getElementById('mcs-chart-lost-btn')){
    var lb=document.createElement('button');
    lb.id='mcs-chart-lost-btn';
    lb.className='mcs-btn-ghost';
    lb.style.fontSize='10px';lb.style.padding='4px 10px';
    lb.onclick=function(){ chartShowLost=!chartShowLost; renderChart(); };
    dhead.appendChild(lb);
  }
  var lostBtn=document.getElementById('mcs-chart-lost-btn');
  if(lostBtn){
    lostBtn.textContent='Ganho × Perdidos';
    lostBtn.style.color=chartShowLost?'var(--ink)':'var(--mut)';
  }
  drawChart(document.getElementById('mcs-chart-daily'),'daily');
  drawChart(document.getElementById('mcs-chart-total'),'total');
}
function drawChart(el,chartMode){
  if(!el)return;

  var history=igFollowerHistory.slice().sort(function(a,b){return a.date<b.date?-1:1;});
  if(chartMode==='daily') history=history.filter(function(v){return v.daily!=null;});
  if(!history.length){
    el.innerHTML='<div style="height:120px;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:6px;color:var(--mut);font-size:11px;text-align:center;padding:0 20px">'
      +'<span style="text-transform:uppercase;letter-spacing:.06em">Sem dados ainda</span>'
      +'<span style="font-size:10px;opacity:.7">O histórico se preenche nos próximos dias (um snapshot por dia).</span>'
      +'</div>';
    return;
  }

  var n=history.length;
  var days=history.map(function(v){return v.date;});
  var gained=history.map(function(v){return v.gained!=null?Number(v.gained):Math.max(0,Number(v.daily||0));});
  var lost  =history.map(function(v){return v.lost!=null?Number(v.lost):Math.max(0,-Number(v.daily||0));});
  var net   =history.map(function(v){return Number(v.daily||0);});
  /* GANHO x PERDA: só no diário, com o toggle ligado */
  var glMode=(chartMode==='daily' && chartShowLost);
  /* SALDO diário (toggle desligado) = eixo simétrico */
  var symMode=(chartMode==='daily' && !chartShowLost);

  var W=el.clientWidth||800;
  var H=160,padL=62,padR=16,padT=20,padB=28;
  var plotW=W-padL-padR, plotH=H-padT-padB;
  function xPos(i){return padL+(i/(Math.max(n-1,1)))*plotW;}

  var vals, vMin, vMax, peak=1;
  if(chartMode==='total'){ vals=history.map(function(v){return Number(v.total||0);}); vMin=Math.min.apply(null,vals); vMax=Math.max.apply(null,vals)||1; }
  else if(glMode){ peak=Math.max(1,Math.max.apply(null,gained),Math.max.apply(null,lost)); vMin=0; vMax=peak; vals=net; }
  else { /* saldo simétrico */ var pk=Math.max(1,Math.abs(Math.min.apply(null,net)),Math.abs(Math.max.apply(null,net))); vMin=-pk; vMax=pk; peak=pk; vals=net; }
  var vRange=vMax-vMin||1;
  function yV(v){return padT+plotH-(((v-vMin)/vRange)*plotH);}
  function ptsStr(arr){return arr.map(function(v,i){return xPos(i).toFixed(1)+','+yV(v).toFixed(1);}).join(' ');}
  function polyLen(arr){var L=0;for(var i=1;i<arr.length;i++){var dx=xPos(i)-xPos(i-1),dy=yV(arr[i])-yV(arr[i-1]);L+=Math.sqrt(dx*dx+dy*dy);}return Math.max(1,L);}

  var svg='<svg width="'+W+'" height="'+H+'" style="display:block;font-family:\'SF Mono\',ui-monospace,monospace">';
  if(symMode){
    /* grid simétrico +pk .. -pk (rótulos com sinal), zero destacado */
    [1,0.5,0,-0.5,-1].forEach(function(fr){
      var yy=yV(peak*fr);
      svg+='<line x1="'+padL+'" y1="'+yy.toFixed(1)+'" x2="'+(W-padR)+'" y2="'+yy.toFixed(1)+'" stroke="rgba(255,255,255,'+(fr===0?'.28':'.06')+')" stroke-width="1"'+(fr===0?' stroke-dasharray="4,3"':'')+'/>';
      svg+='<text x="'+(padL-6)+'" y="'+(yy+4).toFixed(1)+'" text-anchor="end" fill="rgba(255,255,255,.35)" font-size="10">'+(fr>0?'+':'')+fmtNum(Math.round(peak*fr))+'</text>';
    });
  } else {
    /* grid positivo normal (rótulos sem sinal) — usado no total e no ganho x perda */
    for(var gi=0;gi<=4;gi++){
      var gy=padT+(plotH/4)*gi;
      var yVal=vMax-((vRange/4)*gi);
      svg+='<line x1="'+padL+'" y1="'+gy+'" x2="'+(W-padR)+'" y2="'+gy+'" stroke="rgba(255,255,255,.06)" stroke-width="1"/>';
      svg+='<text x="'+(padL-6)+'" y="'+(gy+4)+'" text-anchor="end" fill="rgba(255,255,255,.35)" font-size="10">'+fmtNum(Math.round(yVal))+'</text>';
    }
  }
  var xStep=Math.max(1,Math.floor(n/6));
  for(var xi=0;xi<n;xi+=xStep){
    svg+='<text x="'+xPos(xi).toFixed(1)+'" y="'+(H-6)+'" text-anchor="middle" fill="rgba(255,255,255,.35)" font-size="10">'+fmtDate(days[xi])+'</text>';
  }

  if(glMode){
    /* duas linhas SUBINDO: ganhos (amarelo, estilo total) e perdas (vermelho), ambos positivos */
    var baseY=yV(0);
    var gPts=ptsStr(gained), lPts=ptsStr(lost);
    if(n>=2){
      svg+='<polygon points="'+padL+','+baseY.toFixed(1)+' '+gPts+' '+(W-padR)+','+baseY.toFixed(1)+'" fill="rgba(255,255,255,.04)" class="mcs-chart-area"/>';
      var lLen=polyLen(lost);
      svg+='<polyline points="'+lPts+'" fill="none" stroke="#ff4d4d" stroke-width="2" stroke-linejoin="round" class="mcs-chart-line" style="--len:'+lLen.toFixed(0)+';stroke-dasharray:'+lLen.toFixed(0)+';stroke-dashoffset:'+lLen.toFixed(0)+'"/>';
      var gLen=polyLen(gained);
      svg+='<polyline points="'+gPts+'" fill="none" stroke="#ffffff" stroke-width="2" stroke-linejoin="round" class="mcs-chart-line" style="--len:'+gLen.toFixed(0)+';stroke-dasharray:'+gLen.toFixed(0)+';stroke-dashoffset:'+gLen.toFixed(0)+'"/>';
      /* bolinhas nas extremidades (início e fim) das duas linhas */
      [0,n-1].forEach(function(ix){
        svg+='<circle cx="'+xPos(ix).toFixed(1)+'" cy="'+yV(gained[ix]).toFixed(1)+'" r="3" fill="#ffffff" stroke="#0a0a0a" stroke-width="1.5"/>';
        svg+='<circle cx="'+xPos(ix).toFixed(1)+'" cy="'+yV(lost[ix]).toFixed(1)+'" r="3" fill="#ff4d4d" stroke="#0a0a0a" stroke-width="1.5"/>';
      });
    } else {
      svg+='<circle cx="'+xPos(0)+'" cy="'+yV(gained[0])+'" r="4" fill="#ffffff" stroke="#0a0a0a" stroke-width="2"/>';
      svg+='<circle cx="'+xPos(0)+'" cy="'+yV(lost[0])+'" r="4" fill="#ff4d4d" stroke="#0a0a0a" stroke-width="2"/>';
    }
    svg+='<circle class="mcs-chart-mk" cx="0" cy="0" r="4.5" fill="#ffffff" stroke="#0a0a0a" stroke-width="2" style="display:none"/>';
    svg+='<circle class="mcs-chart-mk2" cx="0" cy="0" r="4" fill="#ff4d4d" stroke="#0a0a0a" stroke-width="2" style="display:none"/>';
  } else {
    var mainColor=chartMode==='daily'?'#ffffff':'#fff200';
    var mainPts=ptsStr(vals), mainLen=polyLen(vals);
    if(symMode){
      /* área discreta da linha do saldo até o zero */
      var zeroY=yV(0);
      svg+='<polygon points="'+padL+','+zeroY.toFixed(1)+' '+mainPts+' '+(W-padR)+','+zeroY.toFixed(1)+'" fill="rgba(255,255,255,.04)" class="mcs-chart-area"/>';
    } else {
      svg+='<polygon points="'+padL+','+(padT+plotH)+' '+mainPts+' '+(W-padR)+','+(padT+plotH)+'" fill="rgba(255,242,0,.07)" class="mcs-chart-area"/>';
    }
    if(n>=2){
      svg+='<polyline points="'+mainPts+'" fill="none" stroke="'+mainColor+'" stroke-width="2" stroke-linejoin="round" class="mcs-chart-line" style="--len:'+mainLen.toFixed(0)+';stroke-dasharray:'+mainLen.toFixed(0)+';stroke-dashoffset:'+mainLen.toFixed(0)+'"/>';
    } else {
      svg+='<circle cx="'+xPos(0)+'" cy="'+yV(vals[0])+'" r="4" fill="'+mainColor+'" stroke="#0a0a0a" stroke-width="2"/>';
      svg+='<text x="'+xPos(0)+'" y="'+(yV(vals[0])-10)+'" text-anchor="middle" fill="var(--txt)" font-size="11" font-family="\'SF Mono\',ui-monospace,monospace">'+(chartMode==='total'?fmtNum(vals[0]):(vals[0]>=0?'+':'')+fmtNum(vals[0]))+'</text>';
    }
    if(n>=2&&chartMode==='daily'&&n<=60){
      for(var di=0;di<n;di++){
        var dc=vals[di]>=0?'#48f91e':'#ff4d4d';
        svg+='<circle cx="'+xPos(di)+'" cy="'+yV(vals[di])+'" r="'+(n<=20?3:2)+'" fill="'+dc+'" class="mcs-chart-dot"/>';
      }
    }
    svg+='<circle class="mcs-chart-mk" cx="0" cy="0" r="4.5" fill="'+mainColor+'" stroke="#0a0a0a" stroke-width="2" style="display:none"/>';
  }
  svg+='</svg>';

  el.style.position='relative';
  el.innerHTML=svg
    +'<div class="mcs-chart-overlay" style="position:absolute;top:0;left:0;width:100%;height:'+(H+padB)+'px;cursor:crosshair"></div>'
    +'<div class="mcs-chart-tip" style="position:absolute;top:6px;pointer-events:none;display:none;background:var(--panel);border:1px solid var(--line2);padding:6px 10px;font-size:11px;font-family:\'SF Mono\',ui-monospace,monospace;white-space:nowrap;z-index:10"></div>';

  requestAnimationFrame(function(){
    Array.prototype.forEach.call(el.querySelectorAll('.mcs-chart-line'),function(pp){ pp.style.strokeDashoffset='0'; });
  });

  var overlay=el.querySelector('.mcs-chart-overlay');
  var tip=el.querySelector('.mcs-chart-tip');
  var mk=el.querySelector('.mcs-chart-mk');
  var mk2=el.querySelector('.mcs-chart-mk2');
  if(overlay&&tip){
    overlay.onmousemove=function(e){
      var rect=overlay.getBoundingClientRect();
      var relX=(e.clientX-rect.left-padL)/plotW;
      var idx=Math.max(0,Math.min(n-1,Math.round(relX*(n-1))));
      var day=days[idx];
      tip.style.display='block';
      tip.style.left=Math.min(e.clientX-rect.left+14,rect.width-190)+'px';
      if(glMode){
        tip.innerHTML='<span style="color:var(--mut);font-size:9px;text-transform:uppercase">'+fmtDate(day)+'</span>'
          +'<br><span style="font-weight:700;color:var(--acc)">'+fmtNum(gained[idx])+'</span> <span style="color:var(--mut);font-size:10px">ganhos</span>'
          +'<br><span style="font-weight:700;color:var(--bad)">'+fmtNum(lost[idx])+'</span> <span style="color:var(--mut);font-size:10px">perdidos</span>'
          +'<br><span style="font-weight:700;color:var(--ink)">'+(net[idx]>=0?'+':'')+fmtNum(net[idx])+'</span> <span style="color:var(--mut);font-size:10px">saldo</span>';
        if(mk){mk.style.display='';mk.setAttribute('cx',xPos(idx).toFixed(1));mk.setAttribute('cy',yV(gained[idx]).toFixed(1));}
        if(mk2){mk2.style.display='';mk2.setAttribute('cx',xPos(idx).toFixed(1));mk2.setAttribute('cy',yV(lost[idx]).toFixed(1));}
      } else {
        var val=vals[idx];
        var sign=val>=0?'+':'';
        var color=chartMode==='daily'?(val>=0?'var(--good)':'var(--bad)'):'var(--acc)';
        tip.innerHTML='<span style="color:var(--mut);font-size:9px;text-transform:uppercase">'+fmtDate(day)+'</span>'
          +'<br><span style="font-weight:700;color:'+color+'">'+sign+fmtNum(val)+'</span>'
          +' <span style="color:var(--mut);font-size:10px">'+(chartMode==='daily'?'saldo':'seguidores')+'</span>';
        if(mk){mk.style.display='';mk.setAttribute('cx',xPos(idx).toFixed(1));mk.setAttribute('cy',yV(val).toFixed(1));}
      }
    };
    overlay.onmouseleave=function(){tip.style.display='none';if(mk)mk.style.display='none';if(mk2)mk2.style.display='none';};
  }
}

/* #7: zera o border-radius de tudo na página social (só carrega aqui) */
function injectSquareStyle(){
  if(document.getElementById('mcs-square-style'))return;
  var s=document.createElement('style');
  s.id='mcs-square-style';
  s.textContent=
    '#mc-root [class*="mcs-"],#mc-root [class*="mcg-"],#mc-root .mc-panel,'
   +'#mc-root .mcs-dm-ava,#mc-root .mcs-dm-ava img,#mc-root .mcs-ccc-medal,'
   +'#mc-root .mcs-badge,#mc-root .mcs-tag,#mc-root .mcs-msg-thumb,'
   +'#mc-root .mcs-ccc-total,#mc-root .mcs-ccc-thumb,#mc-root .mcs-ccc-barwrap,#mc-root .mcs-ccc-bar,'
   +'#mc-root .mcs-dm-bubble,#mc-root .mcs-dm-input,#mc-root .mcs-btn-acc,#mc-root .mcs-btn-ghost'
   +'{border-radius:0 !important}'
   /* avatares/fotos de perfil continuam REDONDOS (o quadrado deixava o anel de
      cor do Instagram aparecendo como um quadrado atrás) */
   +'#mc-root .mcs-avatar,#mc-root .mcs-avatar img,#mc-root .mcs-dm-ava,#mc-root .mcs-dm-ava img,#mc-root .mcs-msg-avatar{border-radius:50% !important}';
  document.head.appendChild(s);
}
function ensureChartCss(){
  if(document.getElementById('mcs-chart-style'))return;
  var s=document.createElement('style');
  s.id='mcs-chart-style';
  s.textContent=
    '.mcs-charts-2col{display:grid;grid-template-columns:1fr 1fr;gap:16px}'
   +'@media(max-width:900px){.mcs-charts-2col{grid-template-columns:1fr}}'
   +'.mcs-chart-line{transition:stroke-dashoffset .9s cubic-bezier(.22,.61,.36,1)}'
   +'.mcs-chart-dot{opacity:0;animation:mcsDotIn .4s ease forwards;animation-delay:.5s}'
   +'.mcs-chart-area{opacity:0;animation:mcsAreaIn .6s ease forwards;animation-delay:.4s}'
   +'@keyframes mcsDotIn{to{opacity:1}}'
   +'@keyframes mcsAreaIn{to{opacity:1}}';
  document.head.appendChild(s);
}

function setStatus(msg){document.getElementById('mcs-updated').textContent=msg;}

/* ── DMs — gaveta de conversas (lista → conversa) ── */
var dmsConvos=[];       // [{peerId,username,avatar,msgs:[...]}]
var dmsActivePeer=null; // peer_id da conversa aberta

/* carrega o web-component do picker completo (todos os emojis + busca) 1x */
var _emojiLoaded=false;
function loadEmojiPicker(){
  if(_emojiLoaded)return; _emojiLoaded=true;
  var sc=document.createElement('script');
  sc.type='module';
  sc.textContent="import 'https://cdn.jsdelivr.net/npm/emoji-picker-element@^1/index.js';";
  document.head.appendChild(sc);
}
function injectDmStyles(){
  if(document.getElementById('mcs-dm-style'))return;
  var s=document.createElement('style');
  s.id='mcs-dm-style';
  s.textContent=
    '.mcs-dm-row{display:flex;align-items:center;gap:10px;padding:10px 12px;border-bottom:1px solid var(--line);cursor:pointer}'
   +'.mcs-dm-row:hover{background:rgba(255,255,255,.04)}'
   +'.mcs-dm-ava{width:38px;height:38px;border-radius:50%;flex:0 0 38px;background:#2a2a2a;display:flex;align-items:center;justify-content:center;font-weight:700;font-size:12px;color:#8a8a8a;overflow:hidden}'
   +'.mcs-dm-ava img{width:100%;height:100%;object-fit:cover;border-radius:50%}'
   +'.mcs-dm-mid{flex:1;min-width:0}'
   +'.mcs-dm-user{font-size:12px;font-weight:700;margin-bottom:2px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}'
   +'.mcs-dm-last{font-size:11px;color:var(--mut);overflow:hidden;white-space:nowrap;text-overflow:ellipsis}'
   +'.mcs-dm-time{font-size:9px;color:var(--mut);flex:0 0 auto;margin-left:6px}'
   +'.mcs-dm-thread{display:flex;flex-direction:column;flex:1;height:100%;min-height:0;max-height:none}'
   +'.mcs-dm-thead{display:flex;align-items:center;gap:10px;padding:8px 10px;border-bottom:1px solid var(--line2);flex:0 0 auto}'
   +'.mcs-dm-back{background:none;border:1px solid var(--line2);color:var(--ink);font-family:inherit;font-size:12px;padding:4px 10px;cursor:pointer}'
   +'.mcs-dm-back:hover{border-color:var(--acc);color:var(--acc)}'
   +'.mcs-dm-thead .mcs-dm-ava{width:30px;height:30px;flex:0 0 30px;font-size:10px}'
   +'.mcs-dm-thead-user{font-size:12px;font-weight:700}'
   +'.mcs-dm-thead a{margin-left:auto;font-size:10px;color:var(--mut);text-decoration:none}'
   +'.mcs-dm-thead a:hover{color:var(--acc)}'
   +'.mcs-dm-msgs{flex:1;overflow-y:auto;padding:12px 10px;display:flex;flex-direction:column;gap:8px;min-height:0}'
   +'.mcs-dm-bubble{max-width:78%;padding:8px 11px;border-radius:12px;font-size:12px;line-height:1.45;word-wrap:break-word;white-space:pre-wrap}'
   +'.mcs-dm-bubble.in{align-self:flex-start;background:#1e1e1e;color:var(--ink);border-bottom-left-radius:3px}'
   +'.mcs-dm-bubble.out{align-self:flex-end;background:var(--acc);color:#000;border-bottom-right-radius:3px;font-weight:500}'
   +'.mcs-dm-bts{font-size:8px;opacity:.65;display:block;margin-top:3px;text-align:right}'
   /* barra de resposta */
   +'.mcs-dm-replybar{display:flex;align-items:center;gap:6px;padding:8px;border-top:1px solid var(--line2);flex:0 0 auto}'
   +'.mcs-dm-input{flex:1;height:34px;box-sizing:border-box;background:#161616;border:1px solid var(--line2);color:var(--ink);font-family:inherit;font-size:12px;padding:0 10px;border-radius:0;outline:none;min-width:0}'
   +'.mcs-dm-replybar{align-items:stretch !important}'
   +'.mcs-dm-input:focus{border-color:var(--acc)}'
   +'.mcs-dm-emoji-btn,.mcs-dm-send{flex:0 0 auto;width:34px;height:34px;display:inline-flex;align-items:center;justify-content:center;background:none;border:1px solid var(--line2);cursor:pointer;padding:0;line-height:1;color:var(--ink);transition:border-color .12s,color .12s}'
   +'.mcs-dm-emoji-btn:hover{border-color:var(--acc);color:var(--acc)}'
   +'.mcs-dm-send{color:var(--acc)}'
   +'.mcs-dm-send:hover{background:var(--acc);color:#000;border-color:var(--acc)}'
   +'.mcs-dm-send:disabled{opacity:.4;cursor:default}'
   +'.mcs-dm-bubble.out.is-pending{opacity:.6}'
   +'.mcs-dm-bubble.out.is-failed{background:#3a1010;color:#ff9a9a;border:1px solid var(--bad)}'
   +'.mcs-dm-emojis{display:none;border-top:1px solid var(--line);background:#121212;flex:0 0 auto}'
   +'.mcs-dm-emojis.open{display:block}'
   +'.mcs-emoji-picker{width:100%;height:300px;--background:#121212;--border-color:var(--line);--border-size:0;--input-border-color:var(--line2);--input-font-color:var(--ink);--input-placeholder-color:var(--mut);--indicator-color:var(--acc);--button-active-background:rgba(255,242,0,.15);--button-hover-background:rgba(255,255,255,.06);--category-font-color:var(--mut)}'
   +'.mcs-dm-senderr{font-size:10px;color:var(--bad);padding:2px 10px 6px;display:none}'
   /* gaveta aberta: o container para de rolar, quem rola é a lista de mensagens */
   +'#mcs-ig-dms:has(.mcs-dm-thread){overflow:hidden;display:flex;flex-direction:column}';
  document.head.appendChild(s);
}

/* Alinha a coluna DMs/Comentários: topo no cabeçalho de publicações,
   base na última linha do grid de posts (sem incluir a paginação) */
function syncSideHeight(){
  var area=document.querySelector('.mcs-pub-area');
  var grid=document.getElementById('mcs-ig-media');
  var right=document.querySelector('.mcs-col-right');
  if(!area||!grid||!right)return;
  if(window.innerWidth<=900){right.style.height='';right.style.bottom='';return;}
  var h=grid.getBoundingClientRect().bottom-area.getBoundingClientRect().top;
  if(h>300){right.style.bottom='auto';right.style.height=h+'px';}
}

function dmAvatarHtml(c,extraClass){
  var cls='mcs-dm-ava'+(extraClass?' '+extraClass:'');
  if(c.avatar) return '<div class="'+cls+'"><img src="'+escH(c.avatar)+'" alt="" loading="lazy" onerror="this.parentNode.textContent=\''+escH((c.username||'?').slice(0,2).toUpperCase())+'\'"></div>';
  return '<div class="'+cls+'">'+escH((c.username||'?').slice(0,2).toUpperCase())+'</div>';
}

function loadDMs(append,retry){
  if(dmsLoading)return;
  dmsLoading=true;
  injectDmStyles();
  mcCall('social_ig_messages',{limit:300},function(err,d){
    dmsLoading=false;
    var el=document.getElementById('mcs-ig-dms');
    if(!el)return;
    if(err||!d||d.error){
      var isPending=(d&&d.error==='dms_pending')||false;
      var isTimeout=(err&&err.message==='timeout')||isPending;
      if(isTimeout&&!isPending&&!retry){
        setTimeout(function(){loadDMs(false,true);},4000);
        return;
      }
      el.innerHTML='<div class="mcs-loading" style="padding:20px;text-align:center;flex-direction:column;gap:10px">'
        +(isTimeout
          ?'<span style="font-size:11px;color:var(--mut)">'+(isPending?'DMs sincronizando em segundo plano — aparecem aqui na primeira leitura concluída.':'As DMs demoram muito para carregar via API.')+'</span>'
           +'<a href="https://www.instagram.com/direct/inbox/" target="_blank" rel="noopener" '
           +'style="display:inline-block;margin-top:8px;padding:8px 16px;background:var(--acc);color:#000;'
           +'font-size:11px;font-weight:700;text-decoration:none;border-radius:6px;letter-spacing:.04em">'
           +'Ver DMs no Instagram ↗</a>'
          :escH(d&&d.error?d.error:'Nenhuma DM recente'))
        +'</div>';
      document.getElementById('mcs-ig-dms-count').textContent='0';
      return;
    }
    // Agrupa mensagens por conversa (peer)
    var map={};
    (d.data||[]).forEach(function(m){
      var pid=m.peer_id||m.from_username||m.sender_id||'?';
      if(!map[pid])map[pid]={peerId:pid,username:'',avatar:'',msgs:[]};
      var c=map[pid];
      if(!c.username&&m.from_username)c.username=m.from_username;
      if(!c.avatar&&m.avatar)c.avatar=m.avatar;
      c.msgs.push({text:m.message||'',time:m.created_time||'',dir:m.dir==='out'?'out':'in'});
    });
    dmsConvos=Object.keys(map).map(function(k){
      var c=map[k];
      c.msgs.sort(function(a,b){return new Date(a.time).getTime()-new Date(b.time).getTime();});
      c.last=c.msgs[c.msgs.length-1]||{};
      return c;
    }).sort(function(a,b){return new Date(b.last.time||0).getTime()-new Date(a.last.time||0).getTime();});
    document.getElementById('mcs-ig-dms-count').textContent=String(dmsConvos.length);
    loadIgLinks();
    if(!dmsConvos.length){el.innerHTML='<div class="mcs-loading">Nenhuma DM recente</div>';return;}
    // Mantém a conversa aberta se houver
    if(dmsActivePeer){
      var open=dmsConvos.filter(function(c){return c.peerId===dmsActivePeer;})[0];
      if(open){renderDmThread(open);return;}
      dmsActivePeer=null;
    }
    renderDmList();
  });
}

function dmShortTime(t){
  if(!t)return '';
  var dt=new Date(t),now=new Date();
  if(isNaN(dt.getTime()))return '';
  if(dt.toDateString()===now.toDateString())
    return dt.toLocaleTimeString('pt-BR',{hour:'2-digit',minute:'2-digit'});
  return dt.toLocaleDateString('pt-BR',{day:'2-digit',month:'2-digit'});
}

function renderDmList(){
  var el=document.getElementById('mcs-ig-dms');
  if(!el)return;
  dmsActivePeer=null;
  el.innerHTML='';
  var frag=document.createDocumentFragment();
  dmsConvos.forEach(function(c){
    var row=document.createElement('div');
    row.className='mcs-dm-row';
    var prefix=c.last.dir==='out'?'Você: ':'';
    row.innerHTML=dmAvatarHtml(c)
      +'<div class="mcs-dm-mid">'
      +'<div class="mcs-dm-user">'+escH(c.username||'Usuário')+cliTagHtml(c)+devTagHtml(c)+'</div>'
      +'<div class="mcs-dm-last">'+escH(prefix+(c.last.text||'').slice(0,60))+'</div>'
      +'</div>'
      +'<div class="mcs-dm-time">'+escH(dmShortTime(c.last.time))+'</div>';
    row.addEventListener('click',function(){renderDmThread(c);});
    row.addEventListener('contextmenu',function(ev){ev.preventDefault();openIgLinkMenu(ev,c);});
    frag.appendChild(row);
  });
  el.appendChild(frag);
}

/* ====== Sincronizar DM com cliente da base ====== */
var igLinks={}, igLinksByUser={}, _igLinksLoaded=false, custList=null;
function applyIgLinks(rows){
  igLinks={};igLinksByUser={};
  (rows||[]).forEach(function(r){
    if(!String(r.customer_id||''))return;
    var o={customer_id:r.customer_id,customer_name:r.customer_name};
    if(r.peer_id)igLinks[String(r.peer_id)]=o;
    if(r.ig_username)igLinksByUser[String(r.ig_username).toLowerCase()]=o;
  });
  refreshDmViews();
}
function refreshDmViews(){
  if(dmsActivePeer){var c=dmsConvos.filter(function(x){return x.peerId===dmsActivePeer;})[0];if(c){renderDmThread(c);return;}}
  if(dmsConvos&&dmsConvos.length)renderDmList();
}
function loadIgLinks(){
  if(_igLinksLoaded)return;_igLinksLoaded=true;
  ensureIgLinkStyle();
  // cache primeiro: tags "cliente" aparecem instantaneamente ao abrir a dash
  var stale=cacheGetStale('mcs_iglinks_v1');
  if(stale)applyIgLinks(stale);
  mcCall('ig_links_list',{},function(err,d){
    if(err||!d||!d.rows)return;
    cacheSave('mcs_iglinks_v1',d.rows,TTL_ACCOUNT);
    applyIgLinks(d.rows);
  });
}

/* ====== Devoluções/Trocas ativas dos clientes vinculados ====== */
var devsByCust={}, devsById={}, _devsLoaded=false;
var DEV_ST_LEGACY={'':'Devolução gerada','Aberta':'Devolução gerada','Em aberto':'Devolução gerada','Em trânsito':'Devolução enviada','Recebida':'Aguardando reembolso','Reembolsada':'Aguardando reembolso','Concluída':'Concluído'};
function devStNorm(s){s=String(s||'');return DEV_ST_LEGACY[s]!=null?DEV_ST_LEGACY[s]:s;}
function applyDevsSocial(data){
  devsByCust={};devsById={};
  var itensByDev={};(data.itens||[]).forEach(function(it){(itensByDev[it.devolucao_id]=itensByDev[it.devolucao_id]||[]).push(it);});
  (data.rows||[]).forEach(function(dv){
    if(devStNorm(dv.status)==='Concluído')return; // só ativas
    dv._itens=itensByDev[dv.id]||[];
    devsById[String(dv.id)]=dv;
    var cid=String(dv.customer_id||'');if(!cid)return;
    if(!devsByCust[cid]||new Date(dv.data_devolucao||0)>new Date(devsByCust[cid].data_devolucao||0))devsByCust[cid]=dv;
  });
  refreshDmViews();
}
function loadDevsSocial(){
  if(_devsLoaded)return;_devsLoaded=true;
  var stale=cacheGetStale('mcs_devs_v1');
  if(stale)applyDevsSocial(stale);
  mcCall('devolucoes_list',{},function(err,d){
    if(err||!d||!d.rows)return;
    var data={rows:d.rows,itens:d.itens||[]};
    cacheSave('mcs_devs_v1',data,TTL_ACCOUNT);
    applyDevsSocial(data);
  });
}
function devTagHtml(c){
  var l=igLinkFor(c);if(!l||!String(l.customer_id||''))return '';
  var dv=devsByCust[String(l.customer_id)];if(!dv)return '';
  var troca=String(dv.tipo)==='troca';
  return '<span class="mcs-dev-tag '+(troca?'troca':'dev')+'" data-devid="'+escH(dv.id)+'">'+(troca?'Troca ativa':'Devolução ativa')+'</span>';
}
function igLinkFor(c){
  if(!c)return null;
  return igLinks[String(c.peerId)]||(c.username?igLinksByUser[String(c.username).toLowerCase()]:null)||null;
}
function cliTagHtml(c){
  var l=igLinkFor(c);
  return l?('<span class="mcs-cli-tag" title="Cliente: '+escH(l.customer_name||'')+'">cliente</span>'):'';
}
function ensureIgLinkStyle(){
  if(document.getElementById('mcs-iglink-style'))return;
  var s=document.createElement('style');s.id='mcs-iglink-style';
  /* mesmo design da dashboard: fonte mono, cantos retos, paineis #0d0d0d, bordas finas, acento amarelo.
     Tudo scoped em #mc-root — os elementos sao appendados DENTRO dele pra herdar fonte e variaveis. */
  s.textContent=[
   '@keyframes mcsFade{from{opacity:0;transform:translateY(3px)}to{opacity:1;transform:translateY(0)}}',
   '#mc-root .mcs-cli-tag{display:inline-block;margin-left:6px;font-size:8px;font-weight:600;text-transform:uppercase;letter-spacing:.08em;color:#000;background:var(--acc);padding:2px 6px;vertical-align:middle;line-height:1.4}',
   '#mc-root .mcs-dev-tag{display:inline-block;margin-left:5px;font-size:8px;font-weight:600;text-transform:uppercase;letter-spacing:.08em;padding:2px 6px;vertical-align:middle;line-height:1.4;cursor:help}',
   '#mc-root .mcs-dev-tag.dev{color:#ffb9b9;background:#3d1414;border-left:3px solid #c53a3a}',
   '#mc-root .mcs-dev-tag.troca{color:#f1c36e;background:#413713;border-left:3px solid #ffa500}',
   '#mc-root .mcs-ctx{position:fixed;z-index:100000;background:var(--panel);border:1px solid var(--line2);box-shadow:0 14px 40px rgba(0,0,0,.7);min-width:220px;animation:mcsFade .12s ease}',
   '#mc-root .mcs-ctx button{display:flex;align-items:center;gap:10px;width:100%;background:none;border:none;border-bottom:1px solid var(--line);color:var(--ink);font-family:inherit;font-size:11px;text-transform:uppercase;letter-spacing:.05em;padding:11px 14px;cursor:pointer;text-align:left;transition:background .12s,color .12s}',
   '#mc-root .mcs-ctx button:last-child{border-bottom:none}',
   '#mc-root .mcs-ctx button:hover{background:rgba(255,255,255,.05);color:var(--acc)}',
   '#mc-root .mcs-ctx button svg{opacity:.65;flex:0 0 auto}',
   '#mc-root .mcs-lnk-ov{position:fixed;inset:0;z-index:100001;background:rgba(0,0,0,.72);display:flex;align-items:center;justify-content:center;animation:mcsFade .12s ease}',
   '#mc-root .mcs-lnk{background:var(--panel);border:1px solid var(--line2);width:min(470px,94vw);max-height:82vh;display:flex;flex-direction:column;box-shadow:0 24px 70px rgba(0,0,0,.7)}',
   '#mc-root .mcs-lnk-head{display:flex;justify-content:space-between;align-items:center;padding:14px 16px;border-bottom:1px solid var(--line);font-size:11px;font-weight:600;text-transform:uppercase;letter-spacing:.08em;color:var(--ink)}',
   '#mc-root .mcs-lnk-head .x{background:none;border:none;color:var(--mut);font-size:16px;cursor:pointer;line-height:1;padding:2px 6px;transition:color .15s}',
   '#mc-root .mcs-lnk-head .x:hover{color:var(--ink)}',
   '#mc-root .mcs-lnk-body{padding:14px 16px;display:flex;flex-direction:column;gap:10px;min-height:0;overflow:hidden}',
   '#mc-root .mcs-lnk-sub{font-size:11px;color:var(--mut);line-height:1.5}#mc-root .mcs-lnk-sub b{color:var(--acc);font-weight:600}',
   '#mc-root .mcs-lnk-search{background:#0a0a0a;border:1px solid var(--line2);color:var(--ink);font-family:inherit;font-size:12px;padding:9px 12px;outline:none;transition:border-color .15s}',
   '#mc-root .mcs-lnk-search:focus{border-color:var(--acc)}',
   '#mc-root .mcs-lnk-search::placeholder{color:#5a5a5a}',
   '#mc-root .mcs-lnk-list{overflow-y:auto;border:1px solid var(--line);max-height:44vh;background:#0a0a0a}',
   '#mc-root .mcs-lnk-row{display:flex;align-items:center;gap:10px;padding:9px 12px;border-bottom:1px solid var(--line);cursor:pointer;font-size:12px;color:var(--ink);transition:background .12s}',
   '#mc-root .mcs-lnk-row:hover{background:rgba(255,255,255,.04)}',
   '#mc-root .mcs-lnk-row.sel{background:rgba(255,242,0,.08);box-shadow:inset 3px 0 0 var(--acc)}',
   '#mc-root .mcs-lnk-row .nm{flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}',
   '#mc-root .mcs-lnk-row .mt{color:var(--mut);font-size:10px;flex:0 0 auto}',
   '#mc-root .mcs-lnk-foot{display:flex;gap:8px;padding:12px 16px;border-top:1px solid var(--line);align-items:center}',
   '#mc-root .mcs-lnk-foot button{font-family:inherit;font-size:11px;font-weight:600;text-transform:uppercase;letter-spacing:.05em;padding:9px 14px;cursor:pointer;border:1px solid var(--line2);background:none;color:var(--ink);transition:background .15s}',
   '#mc-root .mcs-lnk-foot button:hover{background:rgba(255,255,255,.06)}',
   '#mc-root .mcs-lnk-foot .ok{background:var(--acc);color:#000;border-color:var(--acc);font-weight:700}',
   '#mc-root .mcs-lnk-foot .ok:hover{filter:brightness(1.1)}',
   '#mc-root .mcs-lnk-foot .ok:disabled{opacity:.35;cursor:default;filter:none}',
   '#mc-root .mcs-lnk-foot .cancel{margin-left:auto}',
   '#mc-root .mcs-lnk-unlink{color:var(--bad);border-color:rgba(255,77,77,.4)!important}',
   '#mc-root .mcs-lnk-unlink:hover{background:rgba(255,77,77,.1)!important}',
   '#mc-root .mcs-devhc{position:fixed;z-index:100002;width:330px;background:var(--panel);border:1px solid var(--line2);box-shadow:0 20px 60px rgba(0,0,0,.75);color:var(--ink);animation:mcsFade .14s ease}',
   '#mc-root .mcs-devhc-head{display:flex;align-items:center;gap:8px;padding:12px 14px;border-bottom:1px solid var(--line)}',
   '#mc-root .mcs-devhc-tipo{font-size:8px;font-weight:600;text-transform:uppercase;letter-spacing:.08em;padding:2px 7px}',
   '#mc-root .mcs-devhc-tipo.dev{color:#ffb9b9;background:#3d1414;border-left:3px solid #c53a3a}',
   '#mc-root .mcs-devhc-tipo.troca{color:#f1c36e;background:#413713;border-left:3px solid #ffa500}',
   '#mc-root .mcs-devhc-ped{font-size:12px;font-weight:600;letter-spacing:.02em}',
   '#mc-root .mcs-devhc-st{margin-left:auto;font-size:8px;font-weight:600;text-transform:uppercase;letter-spacing:.07em;padding:2px 7px;background:#1b1b1b;color:var(--ink);border-left:3px solid #6c6c95}',
   '#mc-root .mcs-devhc-steps{display:flex;align-items:flex-start;padding:14px 14px 6px}',
   '#mc-root .mcs-devhc-step{flex:1;display:flex;flex-direction:column;align-items:center;gap:5px;position:relative}',
   '#mc-root .mcs-devhc-step:not(:first-child):before{content:"";position:absolute;top:4px;right:50%;width:100%;height:2px;background:var(--line2)}',
   '#mc-root .mcs-devhc-step.on:not(:first-child):before{background:var(--acc)}',
   '#mc-root .mcs-devhc-dot{width:9px;height:9px;background:#2a2a2a;position:relative;z-index:1}',
   '#mc-root .mcs-devhc-step.on .mcs-devhc-dot{background:var(--acc)}',
   '#mc-root .mcs-devhc-step.cur .mcs-devhc-dot{box-shadow:0 0 8px rgba(255,242,0,.55)}',
   '#mc-root .mcs-devhc-slb{font-size:7.5px;text-transform:uppercase;letter-spacing:.04em;color:var(--mut);text-align:center;line-height:1.2}',
   '#mc-root .mcs-devhc-step.on .mcs-devhc-slb{color:var(--ink)}',
   '#mc-root .mcs-devhc-step.cur .mcs-devhc-slb{color:var(--acc);font-weight:600}',
   '#mc-root .mcs-devhc-grid{display:grid;grid-template-columns:1fr 1fr;gap:8px 12px;padding:12px 14px;border-bottom:1px solid var(--line)}',
   '#mc-root .mcs-devhc-cell{min-width:0}',
   '#mc-root .mcs-devhc-lb{font-size:8px;text-transform:uppercase;letter-spacing:.08em;color:var(--mut);margin-bottom:2px}',
   '#mc-root .mcs-devhc-vl{font-size:11px;line-height:1.35;overflow:hidden;text-overflow:ellipsis}',
   '#mc-root .mcs-devhc-vl a{color:var(--acc);text-decoration:none;font-size:11px}',
   '#mc-root .mcs-devhc-vl a:hover{text-decoration:underline}',
   '#mc-root .mcs-devhc-vl small{display:block;color:var(--mut);font-size:9px;margin-top:1px;text-transform:uppercase}',
   '#mc-root .mcs-devhc-its{padding:10px 14px;display:flex;flex-direction:column;gap:6px;max-height:150px;overflow-y:auto}',
   '#mc-root .mcs-devhc-it{display:flex;align-items:center;gap:8px;font-size:11px}',
   '#mc-root .mcs-devhc-it .t{flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}',
   '#mc-root .mcs-devhc-it .sz{flex:0 0 auto;font-size:9px;color:var(--mut);background:#1b1b1b;padding:2px 6px}',
   '#mc-root .mcs-devhc-it .sz b{color:var(--acc);font-weight:600}',
   '#mc-root .mcs-devhc-it .q{flex:0 0 auto;font-size:9px;color:var(--mut)}',
   '#mc-root .mcs-devhc-foot{display:flex;justify-content:space-between;align-items:center;padding:10px 14px;border-top:1px solid var(--line);font-size:10px;color:var(--mut);text-transform:uppercase;letter-spacing:.05em}',
   '#mc-root .mcs-devhc-foot b{color:var(--ink);font-size:12px}'
  ].join('');
  document.head.appendChild(s);
}
var _mcsRoot=null;
function mcsRootEl(){if(!_mcsRoot)_mcsRoot=document.getElementById('mc-root')||document.body;return _mcsRoot;}
/* ── hover card da devolução/troca ativa ── */
var _devHc=null,_devHcT=null;
function closeDevHc(){if(_devHc&&_devHc.parentNode)_devHc.parentNode.removeChild(_devHc);_devHc=null;}
function BRLs(v){return 'R$ '+Number(v||0).toLocaleString('pt-BR',{minimumFractionDigits:2,maximumFractionDigits:2});}
function devHcHtml(dv){
  var troca=String(dv.tipo)==='troca';
  var st=devStNorm(dv.status);
  var steps=troca
    ?[{l:'Gerada',s:'Devolução gerada'},{l:'Enviada',s:'Devolução enviada'},{l:'Recebida',s:'Aguardando reenvio'},{l:'Produção',s:'Em produção'},{l:'Reenviado',s:'Reenviado'},{l:'Entregue',s:'Concluído'}]
    :[{l:'Gerada',s:'Devolução gerada'},{l:'Enviada',s:'Devolução enviada'},{l:'Recebida',s:'Aguardando reembolso'},{l:'Reembolsado',s:'Concluído'}];
  var cur=0;steps.forEach(function(sp,i){if(sp.s===st)cur=i;});
  var stepsH=steps.map(function(sp,i){
    return '<div class="mcs-devhc-step'+(i<=cur?' on':'')+(i===cur?' cur':'')+'"><span class="mcs-devhc-dot"></span><span class="mcs-devhc-slb">'+sp.l+'</span></div>';
  }).join('');
  // rastreio relevante: troca com código de reenvio rastreia o reenvio
  var code='',ev='',loc='',lbl='';
  if(troca&&String(dv.tracking_troca||'').trim()){code=dv.tracking_troca;ev=dv.troca_evento||'';loc=dv.troca_local||'';lbl='reenvio';}
  else if(String(dv.tracking_retorno||'').trim()){code=dv.tracking_retorno;ev=dv.ret_evento||'';loc=dv.ret_local||'';lbl='devolução';}
  var c=String(code).replace(/\s/g,'');
  var itsH=(dv._itens||[]).map(function(it){
    var sz=it.tamanho||'';
    var szH=troca&&it.novo_tamanho?('<span class="sz">'+escH(sz)+' → <b>'+escH(it.novo_tamanho)+'</b></span>'):(sz?('<span class="sz">'+escH(sz)+'</span>'):'');
    return '<div class="mcs-devhc-it"><span class="t" title="'+escH(it.title)+'">'+escH(it.title)+'</span>'+szH+'<span class="q">×'+(Number(it.quantity)||1)+'</span></div>';
  }).join('')||'<div class="mcs-devhc-it" style="color:#8f8f8f">Sem itens registrados</div>';
  return '<div class="mcs-devhc-head">'+
      '<span class="mcs-devhc-tipo '+(troca?'troca':'dev')+'">'+(troca?'Troca':'Devolução')+'</span>'+
      '<span class="mcs-devhc-ped">#MNC'+escH(dv.order_number)+'</span>'+
      '<span class="mcs-devhc-st">'+escH(st)+'</span></div>'+
    '<div class="mcs-devhc-steps">'+stepsH+'</div>'+
    '<div class="mcs-devhc-grid">'+
      '<div class="mcs-devhc-cell"><div class="mcs-devhc-lb">Motivo</div><div class="mcs-devhc-vl">'+escH(dv.motivo||'—')+'</div></div>'+
      '<div class="mcs-devhc-cell"><div class="mcs-devhc-lb">Data</div><div class="mcs-devhc-vl">'+escH((dv.data_devolucao||'').slice(0,10).split('-').reverse().join('/'))+'</div></div>'+
      '<div class="mcs-devhc-cell"><div class="mcs-devhc-lb">Rastreio'+(lbl?(' · '+lbl):'')+'</div><div class="mcs-devhc-vl">'+(c?('<a href="https://rastreio.frenet.com.br/COR/'+escH(c)+'" target="_blank" rel="noopener">'+escH(c)+'</a>'):'—')+'</div></div>'+
      '<div class="mcs-devhc-cell"><div class="mcs-devhc-lb">Estágio</div><div class="mcs-devhc-vl">'+escH(ev||'—')+(loc?('<small>'+escH(loc)+'</small>'):'')+'</div></div>'+
    '</div>'+
    '<div class="mcs-devhc-its">'+itsH+'</div>'+
    '<div class="mcs-devhc-foot"><span>'+(Number(dv.qtd_itens)||0)+' '+(Number(dv.qtd_itens)===1?'item':'itens')+'</span><b>'+BRLs(dv.valor_itens)+'</b></div>';
}
function showDevHc(tag){
  closeDevHc();
  var dv=devsById[String(tag.getAttribute('data-devid'))];if(!dv)return;
  ensureIgLinkStyle();
  var hc=document.createElement('div');hc.className='mcs-devhc';hc.innerHTML=devHcHtml(dv);
  mcsRootEl().appendChild(hc);_devHc=hc;
  var r=tag.getBoundingClientRect();
  var x=Math.max(8,Math.min(r.left,window.innerWidth-hc.offsetWidth-8));
  var y=r.bottom+8;
  if(y+hc.offsetHeight>window.innerHeight-8)y=r.top-hc.offsetHeight-8;
  hc.style.left=x+'px';hc.style.top=Math.max(8,y)+'px';
  hc.addEventListener('mouseenter',function(){clearTimeout(_devHcT);});
  hc.addEventListener('mouseleave',function(){_devHcT=setTimeout(closeDevHc,150);});
}
document.addEventListener('mouseover',function(e){
  var tag=e.target.closest&&e.target.closest('.mcs-dev-tag');
  if(tag){clearTimeout(_devHcT);showDevHc(tag);}
});
document.addEventListener('mouseout',function(e){
  if(e.target.closest&&e.target.closest('.mcs-dev-tag')){_devHcT=setTimeout(closeDevHc,150);}
});
var _ctxEl=null;
function closeCtx(){if(_ctxEl&&_ctxEl.parentNode)_ctxEl.parentNode.removeChild(_ctxEl);_ctxEl=null;}
document.addEventListener('click',closeCtx);
document.addEventListener('scroll',closeCtx,true);
function openIgLinkMenu(ev,c){
  ensureIgLinkStyle();closeCtx();
  var m=document.createElement('div');m.className='mcs-ctx';
  var linked=igLinkFor(c);
  m.innerHTML='<button data-a="sync"><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polyline points="17 1 21 5 17 9"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><polyline points="7 23 3 19 7 15"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/></svg>Sincronizar com a base</button>'+
    (linked?'<button data-a="open" style="color:var(--mut)"><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="8" r="4"/><path d="M4 21a8 8 0 0 1 16 0"/></svg>Vinculado: '+escH(linked.customer_name||'')+'</button>':'');
  m.style.left=Math.min(ev.clientX,window.innerWidth-210)+'px';
  m.style.top=Math.min(ev.clientY,window.innerHeight-120)+'px';
  m.addEventListener('click',function(e){e.stopPropagation();var b=e.target.closest('button');if(!b)return;closeCtx();openIgLinkModal(c);});
  mcsRootEl().appendChild(m);_ctxEl=m;
}
function loadCustomers(cb){
  if(custList){cb(custList);return;}
  var stale=cacheGetStale('mc_cust_list_v1');if(stale){custList=stale;cb(custList);}
  mcCall('customers',{},function(err,d){
    if(!err&&d&&d.rows){custList=d.rows;try{localStorage.setItem('mc_cust_list_v1',JSON.stringify({t:Date.now(),d:custList}));}catch(e){}cb(custList);}
    else if(!custList)cb([]);
  });
}
function openIgLinkModal(c){
  ensureIgLinkStyle();
  var sel=null,linked=igLinkFor(c);
  var ov=document.createElement('div');ov.className='mcs-lnk-ov';
  ov.innerHTML='<div class="mcs-lnk">'+
    '<div class="mcs-lnk-head"><span>Sincronizar DM</span><button class="x">✕</button></div>'+
    '<div class="mcs-lnk-body"><div class="mcs-lnk-sub">Vincular <b>@'+escH(c.username||c.peerId)+'</b> a um cliente da base'+(linked?(' — atual: '+escH(linked.customer_name||'')):'')+'</div>'+
    '<input class="mcs-lnk-search" placeholder="Buscar cliente por nome, telefone...">'+
    '<div class="mcs-lnk-list"><div style="padding:12px;color:var(--mut);font-size:11px">Carregando clientes...</div></div></div>'+
    '<div class="mcs-lnk-foot">'+(linked?'<button class="mcs-lnk-unlink">Desvincular</button>':'')+'<button class="cancel">Cancelar</button><button class="ok" disabled>Confirmar</button></div>'+
    '</div>';
  mcsRootEl().appendChild(ov);
  var listEl=ov.querySelector('.mcs-lnk-list'),search=ov.querySelector('.mcs-lnk-search'),okBtn=ov.querySelector('.ok');
  function close(){if(ov.parentNode)ov.parentNode.removeChild(ov);}
  ov.addEventListener('click',function(e){if(e.target===ov)close();});
  ov.querySelector('.x').addEventListener('click',close);
  ov.querySelector('.cancel').addEventListener('click',close);
  var unb=ov.querySelector('.mcs-lnk-unlink');
  if(unb)unb.addEventListener('click',function(){saveIgLink(c,'','');close();});
  function draw(rows){
    if(!rows.length){listEl.innerHTML='<div style="padding:12px;color:var(--mut);font-size:11px">Nenhum cliente encontrado.</div>';return;}
    listEl.innerHTML=rows.slice(0,80).map(function(r){
      var id=r.id||r.customer_id||'';var nm=r.nome||r.customer_name||'—';
      return '<div class="mcs-lnk-row" data-id="'+escH(id)+'" data-nm="'+escH(nm)+'"><span class="nm">'+escH(nm)+'</span><span class="mt">'+escH(r.phone||r.cidade||'')+'</span></div>';
    }).join('');
    listEl.querySelectorAll('.mcs-lnk-row').forEach(function(row){
      row.addEventListener('click',function(){
        listEl.querySelectorAll('.mcs-lnk-row.sel').forEach(function(x){x.classList.remove('sel');});
        row.classList.add('sel');sel={id:row.getAttribute('data-id'),nm:row.getAttribute('data-nm')};okBtn.disabled=false;
      });
    });
  }
  loadCustomers(function(all){
    all=(all||[]).filter(function(r){return (r.nome||r.customer_name);});
    draw(all);
    search.addEventListener('input',function(){
      var q=search.value.toLowerCase().trim();
      draw(!q?all:all.filter(function(r){return ((r.nome||'')+' '+(r.phone||'')+' '+(r.email||'')).toLowerCase().indexOf(q)>=0;}));
    });
    setTimeout(function(){search.focus();},50);
  });
  okBtn.addEventListener('click',function(){if(!sel)return;saveIgLink(c,sel.id,sel.nm);close();});
}
function saveIgLink(c,cid,cnm){
  var o=(cid?{customer_id:cid,customer_name:cnm}:null);
  if(o){igLinks[String(c.peerId)]=o;if(c.username)igLinksByUser[String(c.username).toLowerCase()]=o;}
  else{delete igLinks[String(c.peerId)];if(c.username)delete igLinksByUser[String(c.username).toLowerCase()];}
  if(dmsActivePeer===c.peerId)renderDmThread(c);else renderDmList();
  mcCall('ig_link_save',{peer_id:c.peerId,ig_username:c.username||'',customer_id:cid||'',customer_name:cnm||''},function(){});
}

var DM_EMOJIS=[
  '😀','😃','😄','😁','😆','😅','😂','🤣','🥲','😊','😇','🙂','🙃','😉','😌','😍','🥰','😘','😗','😙','😚','😋','😛','😝','😜','🤪','🤨','🧐','🤓','😎','🥸','🤩','🥳',
  '😏','😒','😞','😔','😟','😕','🙁','☹️','😣','😖','😫','😩','🥺','😢','😭','😤','😠','😡','🤬','🤯','😳','🥵','🥶','😱','😨','😰','😥','😓','🤗','🤔','🤭','🤫','🤥',
  '😶','😐','😑','😬','🙄','😯','😦','😧','😮','😲','🥱','😴','🤤','😪','😵','🤐','🥴','🤢','🤮','🤧','😷','🤒','🤕','🤑','🤠','😈','👿','👻','💀','☠️','👽','🤖','🎃',
  '😺','😸','😹','😻','😼','😽','🙀','😿','😾',
  '👍','👎','👌','🤌','🤏','✌️','🤞','🤟','🤘','🤙','👈','👉','👆','👇','☝️','✋','🤚','🖐️','🖖','👋','🤝','🙏','✍️','💅','🤳','💪','👏','🙌','👐','🤲','🫶','🫡','🫰',
  '❤️','🧡','💛','💚','💙','💜','🖤','🤍','🤎','💔','❣️','💕','💞','💓','💗','💖','💘','💝','💯','💢','💥','💫','💦','💨','🕳️','💬','💭','🔥','⚡','✨','🌟','⭐','🌈',
  '🎉','🎊','🎈','🎁','🏆','🥇','🥈','🥉','🏅','🎯','🚀','💰','💸','💵','📈','📉','📊','✅','❌','⚠️','❗','❓','💤','🔔','🔒','🔓','🔑','🛒','📦','📸','🎬','🎵','🎶',
  '🚗','🏍️','🛵','🏎️','🚘','🛞','⛽','🏁','🔧','🛠️','🧰'
];

function renderDmThread(c){
  var el=document.getElementById('mcs-ig-dms');
  if(!el)return;
  dmsActivePeer=c.peerId;
  var igLink=c.username?('<a href="https://www.instagram.com/'+escH(c.username)+'/" target="_blank" rel="noopener">ver perfil ↗</a>'):'';
  var html='<div class="mcs-dm-thread">'
    +'<div class="mcs-dm-thead">'
    +'<button class="mcs-dm-back" id="mcs-dm-back">←</button>'
    +dmAvatarHtml(c)
    +'<div class="mcs-dm-thead-user">'+escH(c.username||'Usuário')+cliTagHtml(c)+devTagHtml(c)+'</div>'
    +igLink
    +'</div>'
    +'<div class="mcs-dm-msgs" id="mcs-dm-msgs">';
  c.msgs.forEach(function(m){
    var t=m.time?new Date(m.time).toLocaleString('pt-BR',{day:'2-digit',month:'2-digit',hour:'2-digit',minute:'2-digit'}):'';
    html+='<div class="mcs-dm-bubble '+(m.dir==='out'?'out':'in')+'">'+escH(m.text)
      +'<span class="mcs-dm-bts">'+escH(t)+'</span></div>';
  });
  html+='</div>'
    +'<div class="mcs-dm-senderr" id="mcs-dm-senderr"></div>'
    +'<div class="mcs-dm-emojis" id="mcs-dm-emojis"><emoji-picker class="dark mcs-emoji-picker"></emoji-picker></div>'
    +'<div class="mcs-dm-replybar">'
    +'<button type="button" class="mcs-dm-emoji-btn" id="mcs-dm-emoji-btn" title="Emojis"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M8.5 14a4 4 0 0 0 7 0"/><line x1="9" y1="9.5" x2="9.01" y2="9.5"/><line x1="15" y1="9.5" x2="15.01" y2="9.5"/></svg></button>'
    +'<input type="text" class="mcs-dm-input" id="mcs-dm-input" placeholder="Responder '+escH(c.username||'')+'..." maxlength="900">'
    +'<button type="button" class="mcs-dm-send" id="mcs-dm-send" title="Enviar"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg></button>'
    +'</div>'
    +'</div>';
  el.innerHTML=html;
  document.getElementById('mcs-dm-back').addEventListener('click',renderDmList);
  var thead=el.querySelector('.mcs-dm-thead');
  if(thead)thead.addEventListener('contextmenu',function(ev){ev.preventDefault();openIgLinkMenu(ev,c);});
  var box=document.getElementById('mcs-dm-msgs');
  if(box)box.scrollTop=box.scrollHeight;
  // Barra de resposta
  var input=document.getElementById('mcs-dm-input');
  var sendBtn=document.getElementById('mcs-dm-send');
  var emojiBtn=document.getElementById('mcs-dm-emoji-btn');
  var emojis=document.getElementById('mcs-dm-emojis');
  var errEl=document.getElementById('mcs-dm-senderr');
  emojiBtn.addEventListener('click',function(){ emojis.classList.toggle('open'); loadEmojiPicker(); });
  var picker=emojis.querySelector('emoji-picker');
  if(picker) picker.addEventListener('emoji-click',function(ev){
    var uni=ev.detail&&ev.detail.unicode; if(!uni)return;
    var st=input.selectionStart!=null?input.selectionStart:input.value.length;
    var en=input.selectionEnd!=null?input.selectionEnd:st;
    input.value=input.value.slice(0,st)+uni+input.value.slice(en);
    input.focus();
    input.selectionStart=input.selectionEnd=st+uni.length;
  });
  function sendDm(){
    var text=input.value.trim();
    if(!text)return;
    errEl.style.display='none';
    /* OTIMISTA: o balão aparece na hora (marcado "enviando…") e o campo já
       fica livre pra mandar a próxima — a resposta do servidor só confirma */
    var now=new Date().toISOString();
    var mObj={text:text,time:now,dir:'out',pending:true};
    c.msgs.push(mObj); c.last=mObj;
    var bub=document.createElement('div');
    bub.className='mcs-dm-bubble out is-pending';
    var tsHtml=new Date(now).toLocaleString('pt-BR',{day:'2-digit',month:'2-digit',hour:'2-digit',minute:'2-digit'});
    bub.innerHTML=escH(text)+'<span class="mcs-dm-bts">enviando…</span>';
    box.appendChild(bub);
    box.scrollTop=box.scrollHeight;
    input.value='';
    emojis.classList.remove('open');
    input.focus();
    mcCall('social_ig_send_dm',{peer_id:c.peerId,text:text},function(err,d){
      var ts=bub.querySelector('.mcs-dm-bts');
      var rawMsg=(d&&d.error)||(err&&err.message)||'';
      var is24=/24|window|allowed|janela/i.test(rawMsg);
      var isReal=is24||/block|permission|invalid|not\s|forbidden|denied/i.test(rawMsg);
      if(is24 || (isReal && d && d.error)){
        var msg=is24?'Fora da janela de 24h — o Instagram só permite responder até 1 dia após a última mensagem do cliente.':rawMsg;
        errEl.textContent='⚠ '+msg;
        errEl.style.display='block';
        bub.classList.remove('is-pending');
        bub.classList.add('is-failed');
        mObj.failed=true;
        if(ts)ts.textContent='não enviado';
        return;
      }
      /* erro desconhecido / timeout do JSONP: o envio quase sempre foi concluído
         (o GAS estoura o tempo mesmo com sucesso) → mantém como ENVIADA */
      mObj.pending=false;
      bub.classList.remove('is-pending');
      if(ts)ts.textContent=(err||!d)?(tsHtml+' · enviada'):tsHtml;
    });
  }
  sendBtn.addEventListener('click',sendDm);
  input.addEventListener('keydown',function(e){if(e.key==='Enter'){e.preventDefault();sendDm();}});
  input.focus();
}

/* ── Comentários (scroll infinito + respostas persistentes) ── */
function renderComment(c,ci){
  var cid='mcs-cmt-'+ci;
  var time=c.timestamp?new Date(c.timestamp).toLocaleDateString('pt-BR',{day:'2-digit',month:'2-digit',hour:'2-digit',minute:'2-digit'}):'';
  var thumb=c.post_thumb
    ?('<img class="mcs-msg-thumb" src="'+escH(c.post_thumb)+'" alt="" loading="lazy">')
    :'<div class="mcs-msg-avatar">&#128172;</div>';
  var txt=escH(c.text||'');
  var long=(c.text||'').length>120||(c.text||'').split('\n').length>3;
  var clsText='mcs-cmt-text'+(long?' is-clamped':'');
  var expandBtn=long?('<button class="mcs-cmt-expand" id="'+cid+'-btn" onclick="mcSocialExpandCmt(\''+cid+'\')">&#9660; Ver mais</button>'):'';
  var postLink=c.post_url?('<a href="'+escH(c.post_url)+'" target="_blank" rel="noopener" class="mcs-cmt-post-link" onclick="event.stopPropagation()">&#8599; Ver no Instagram</a>'):'';
  var replyKey=c.id||cid;
  // Respostas vindas da API do Instagram (já salvas na plataforma)
  var apiReplies=(c.replies||[]).map(function(r){
    return '<div class="mcs-my-reply"><span class="mcs-my-reply-label">@'+escH(r.username||'você')+'</span> '+escH(r.text||'')+'</div>';
  }).join('');
  // Respostas enviadas nesta sessão via dashboard (ainda não recarregadas da API)
  var apiReplyTexts=(c.replies||[]).map(function(r){return r.text||'';});
  var savedReplies=apiReplies+(cmtReplies[replyKey]||[]).filter(function(t){
    return apiReplyTexts.indexOf(t)<0; // evita duplicar o que já veio da API
  }).map(function(t){
    return '<div class="mcs-my-reply"><span class="mcs-my-reply-label">Você</span> '+escH(t)+'</div>';
  }).join('');
  var div=document.createElement('div');
  div.className='mcs-cmt-item';div.id=cid;
  var openAttr=c.post_url?(' data-openurl="'+escH(c.post_url)+'" style="cursor:pointer" title="Abrir no Instagram"'):'';
  div.innerHTML=
    '<div class="mcs-msg-item"'+openAttr+'>'
      +thumb
      +'<div class="mcs-msg-body">'
        +'<div class="mcs-msg-user">@'+escH(c.username||'')+' '+postLink+'</div>'
        +'<div class="'+clsText+'" id="'+cid+'-text">'+txt+'</div>'
        +expandBtn
      +'</div>'
      +'<div class="mcs-msg-time">'+escH(time)+'</div>'
    +'</div>'
    +savedReplies
    +'<div class="mcs-cmt-actions">'
      +'<button class="mcs-cmt-reply-btn" data-cid="'+cid+'" data-cmtid="'+escH(c.id||'')+'">&#8617; Responder</button>'
    +'</div>'
    +'<div class="mcs-cmt-reply-box" id="'+cid+'-reply" style="display:none">'
      +'<textarea class="mcs-cmt-reply-input" id="'+cid+'-reply-text" placeholder="Escreva sua resposta..." rows="2"></textarea>'
      +'<div class="mcs-cmt-reply-footer">'
        +'<button class="mcs-btn-ghost mcs-cmt-cancel" data-cid="'+cid+'" style="padding:5px 10px;font-size:10px">Cancelar</button>'
        +'<button class="mcs-btn-acc mcs-cmt-send" data-cid="'+cid+'" data-cmtid="'+escH(c.id||'')+'">Enviar</button>'
      +'</div>'
    +'</div>';
  return div;
}

function loadComments(append){
  if(cmtLoading)return;
  cmtLoading=true;
  if(!append){cmtOffset=0;cmtHasMore=true;}
  var el=document.getElementById('mcs-ig-comments');
  // Indicador de carregamento no rodapé
  var spinner=document.getElementById('mcs-cmt-spinner');
  if(spinner) spinner.style.display='';
  var params={offset:append?cmtOffset:0,limit:50};
  mcCall('social_ig_comments',params,function(err,d){
    cmtLoading=false;
    if(spinner) spinner.style.display='none';
    if(!el)return;
    if(err||!d||d.error){
      if(!append){
        el.innerHTML='<div class="mcs-loading">'+(d&&d.error?escH(d.error):'Nenhum comentário recente')+'</div>';
        document.getElementById('mcs-ig-cmt-count').textContent='0';
      }
      return;
    }
    if(!d.data||!d.data.length){
      if(!append) el.innerHTML='<div class="mcs-loading">Nenhum comentário recente</div>';
      cmtHasMore=false;
      return;
    }
    cmtHasMore=!!d.has_more;
    var baseIdx=cmtOffset;
    cmtOffset+=(d.data||[]).length;
    document.getElementById('mcs-ig-cmt-count').textContent=String(cmtOffset)+(cmtHasMore?'+':'');
    if(!append) el.innerHTML='';
    var frag=document.createDocumentFragment();
    (d.data||[]).forEach(function(c,ci){frag.appendChild(renderComment(c,baseIdx+ci));});
    el.appendChild(frag);
    if(!el._eventsBound){
      el._eventsBound=true;
      el.addEventListener('click',function(e){
        /* clicar em qualquer área do comentário (fora de botões/links/textarea)
           abre a publicação no Instagram */
        if(!e.target.closest('button,a,textarea,input')){
          var host=e.target.closest('[data-openurl]');
          if(host){ window.open(host.getAttribute('data-openurl'),'_blank','noopener'); return; }
        }
        var btn=e.target.closest('button');
        if(!btn)return;
        var cid=btn.getAttribute('data-cid');
        if(btn.classList.contains('mcs-cmt-reply-btn')&&cid) mcSocialReplyToggle(cid);
        if(btn.classList.contains('mcs-cmt-cancel')&&cid) mcSocialReplyToggle(cid);
        if(btn.classList.contains('mcs-cmt-send')&&cid) mcSocialSendReply(cid,btn.getAttribute('data-cmtid')||'');
      });
      el.addEventListener('scroll',function(){
        if(el.scrollTop+el.clientHeight>=el.scrollHeight-100&&cmtHasMore&&!cmtLoading) loadComments(true);
      });
    }
  });
}



window.mcSocialExpandCmt=function(id){
  var txt=document.getElementById(id+'-text');
  var btn=document.getElementById(id+'-btn');
  if(!txt)return;
  var clamped=txt.classList.contains('is-clamped');
  if(clamped){txt.classList.remove('is-clamped');if(btn)btn.innerHTML='&#9650; Ver menos';}
  else{txt.classList.add('is-clamped');if(btn)btn.innerHTML='&#9660; Ver mais';}
};

window.mcSocialReplyToggle=function(cid){
  var box=document.getElementById(cid+'-reply');
  if(!box)return;
  var open=box.style.display==='none';
  box.style.display=open?'block':'none';
  if(open){var ta=document.getElementById(cid+'-reply-text');if(ta)ta.focus();}
};

window.mcSocialSendReply=function(cid,commentId){
  var ta=document.getElementById(cid+'-reply-text');
  if(!ta||!ta.value.trim())return;
  var msg=ta.value.trim();
  var btn=document.querySelector('#'+cid+'-reply .mcs-cmt-send');
  if(btn){btn.textContent='Enviando...';btn.disabled=true;}
  mcCall('social_ig_reply_comment',{comment_id:commentId,message:msg},function(err,d){
    if(err||!d||d.error){
      alert('Erro: '+(d&&d.error?d.error:(err?err.message:'Tente novamente')));
      if(btn){btn.textContent='Enviar';btn.disabled=false;}
      return;
    }
    // Persiste resposta em localStorage para re-injetar ao recarregar
    var replyKey=commentId||cid;
    if(!cmtReplies[replyKey]) cmtReplies[replyKey]=[];
    cmtReplies[replyKey].push(msg);
    try{localStorage.setItem('mc_cmt_replies',JSON.stringify(cmtReplies));}catch(e){}
    // Mostra imediatamente no DOM
    var box=document.getElementById(cid+'-reply');
    if(box){
      var replyEl=document.createElement('div');
      replyEl.className='mcs-my-reply';
      replyEl.innerHTML='<span class="mcs-my-reply-label">Você</span> '+escH(msg);
      box.parentNode.insertBefore(replyEl,box);
      box.style.display='none';
    }
    if(ta)ta.value='';
    if(btn){btn.textContent='Enviar';btn.disabled=false;}
  });
};

/* ── Rangepicker (igual aquisição) ── */
var fp=null;
function initRangepicker(){
  var rp=document.getElementById('mcs-rangepicker');
  var toggle=document.getElementById('mcs-range-toggle');
  var opts=document.getElementById('mcs-range-opts');
  var label=document.getElementById('mcs-range-label');
  if(!rp||!toggle)return;

  try{
    if(typeof flatpickr!=='undefined'){
      fp=flatpickr('#mcs-date-input',{mode:'range',locale:'pt',dateFormat:'Y-m-d',maxDate:new Date(),static:false,onChange:function(sel){
        if(sel.length===2){
          var d1=sel[0].toISOString().slice(0,10),d2=sel[1].toISOString().slice(0,10);
          var diff=Math.round((sel[1]-sel[0])/(1000*60*60*24))+1;
          period=diff;
          label.textContent=d1.slice(8)+'/'+d1.slice(5,7)+' — '+d2.slice(8)+'/'+d2.slice(5,7);
          Array.prototype.forEach.call(opts.querySelectorAll('button'),function(x){x.classList.remove('is-active');});
          rp.classList.remove('open');
          igMedia=[];igFollowerHistory=[];igData=null;mediaPage=0;
          loadIG(false);   /* usa o cache (prefetch dos períodos) → troca instantânea */
        }
      }});
    }
  }catch(e){fp=null;}

  function openCal(ref){
    if(!fp)return;
    fp.open();
    setTimeout(function(){
      var cal=document.querySelector('.flatpickr-calendar');
      if(cal&&ref){
        var r=ref.getBoundingClientRect();
        cal.style.position='fixed';
        cal.style.top=(r.bottom+4)+'px';
        cal.style.left=Math.max(4,r.right-cal.offsetWidth)+'px';
        cal.classList.add('dark');
      }
    },0);
  }

  toggle.addEventListener('click',function(){rp.classList.toggle('open');});
  opts.addEventListener('click',function(ev){
    var custom=ev.target.closest('#mcs-custom');
    var b=ev.target.closest('button[data-range]');
    if(custom){
      Array.prototype.forEach.call(opts.querySelectorAll('button'),function(x){x.classList.remove('is-active');});
      rp.classList.remove('open');
      openCal(toggle);
      return;
    }
    if(!b)return;
    var val=parseInt(b.dataset.range)||30;
    period=val;
    Array.prototype.forEach.call(opts.querySelectorAll('button'),function(x){x.classList.remove('is-active');});
    b.classList.add('is-active');
    label.textContent = val>=3000 ? 'Máximo' : (val+' dias');
    rp.classList.remove('open');
    igMedia=[];igFollowerHistory=[];igData=null;mediaPage=0;
    loadIG(false);   /* usa o cache do período (não rebusca a cada troca) */
  });

  // fechar ao clicar fora
  document.addEventListener('click',function(ev){
    if(rp&&!rp.contains(ev.target))rp.classList.remove('open');
  });
}

function init(){
  ensureIgLinkStyle();   // estilos das tags/menus prontos desde o load
  loadIgLinks();         // vínculos cliente↔IG (cache-first: tag aparece na hora)
  loadDevsSocial();      // devoluções/trocas ativas (cache-first)
  initRangepicker();
  var mediaTypeSel=document.getElementById('mcs-ig-media-type');
  if(mediaTypeSel){
    mediaTypeSel.addEventListener('change',function(){
      mediaType=this.value; mediaPage=0;
      renderMedia();
      renderTopPosts();
      renderKpis();
    });
  }
  var sortSel=document.getElementById('mcs-ig-sort');
  if(sortSel){
    sortSel.addEventListener('change',function(){
      mediaSort=this.value;
      mediaPage=0;
      renderMedia();
    });
  }
  // Carrega dados iniciais
  injectDmStyles();
  injectSquareStyle();   /* #7: tudo arredondado vira quadrado na página social */
  loadCccVotes();
  loadIG(false);
  setTimeout(prefetchPeriods,4000);   /* pré-carrega 7/30/90 dias em bg (troca instantânea) */
  loadDMs(false);
  loadComments(false);
  checkTokenExpiry();
  // Mantém a coluna lateral alinhada com o grid de posts
  var _grid=document.getElementById('mcs-ig-media');
  if(_grid&&window.ResizeObserver)new ResizeObserver(syncSideHeight).observe(_grid);
  window.addEventListener('resize',syncSideHeight);
  syncSideHeight();
  // DMs novas do webhook aparecem sem recarregar a página
  // (pula o refresh se você estiver digitando uma resposta)
  setInterval(function(){
    var inp=document.getElementById('mcs-dm-input');
    if(inp&&(inp.value.trim()||document.activeElement===inp))return;
    loadDMs(false);
  },120000);
  // votos do CCC em tempo real: atualiza direto do servidor a cada 15s
  setInterval(function(){ loadCccVotes(true); },15000);
  // botão ATUALIZAR do topo (business-guard): limpa o cache e recarrega tudo do servidor
  window.addEventListener('mc:refresh',function(){
    try{
      Object.keys(localStorage).forEach(function(k){
        if(k.indexOf('mc_ig_')===0 || k==='mc_ccc_votes') localStorage.removeItem(k);
      });
    }catch(e){}
    loadIG(true);
    loadDMs(false);
    loadComments(false);
    loadCccVotes(true);
  });
}

/* ── Aviso de expiração do token do Instagram ── */
function checkTokenExpiry(){
  mcCall('ig_token_status',null,function(err,d){
    if(err||!d||d.days_left==null)return;
    if(d.days_left>10)return;
    var root=document.getElementById('mcs-tab-instagram');
    if(!root)return;
    var bar=document.createElement('div');
    var msg=d.days_left<=0
      ?'⚠️ O token do Instagram EXPIROU — DMs e renovação automática pararam. Gere um novo token no painel Meta (produto Instagram) e atualize IG_LOGIN_TOKEN nas propriedades do script.'
      :'⚠️ O token do Instagram expira em '+d.days_left+' dia'+(d.days_left===1?'':'s')+' e a renovação automática pode ter falhado. Confira o trigger igRefreshToken ou gere um novo token no painel Meta.';
    bar.style.cssText='background:#3a2a00;border:1px solid #b8860b;color:#ffd966;padding:10px 14px;'
      +'border-radius:8px;font-size:12px;font-weight:600;margin:0 0 12px;line-height:1.5';
    bar.textContent=msg;
    root.insertBefore(bar,root.firstChild);
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();